import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, Renderer2, SimpleChanges, ViewChild } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import * as replySvg from '@fluentui/svg-icons/icons/arrow_reply_20_regular.svg';
import * as dismissSquareSvgFilled from '@fluentui/svg-icons/icons/dismiss_20_filled.svg';
import * as dismissSquareSvgRegular from '@fluentui/svg-icons/icons/dismiss_20_regular.svg';
import * as meetingSvg from '@fluentui/svg-icons/icons/meet_now_20_regular.svg';
import * as checklistSvg from '@fluentui/svg-icons/icons/task_list_ltr_20_regular.svg';
import { ActionContextMenuItemIcon, ContentActionIcon, Document as DocumentReact, DocumentAction, FileType as FileTypeReact } from '@office-start/document-types';
import { KnownAreas as KnownAreaInst, WdOriginType as WdOriginTypeInst } from '@office-start/instrumentation-types';
import { LaunchAction as LaunchActionReact } from '@office-start/launcher-types';
import { logError, logUserAction } from '@office-start/telemetry-service';
import { Area, DataSecurityLevel as OtelDataSecurityLevel, KnownErrorInstrumentationEvents } from '@office-start/telemetry-types';
import { getReferral } from '@office-start/telemetry-utility';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

import { FluidHostContext } from '../../fluid-content/scopes/fluid-host-context';
import { FluidInstrumentationService } from '../../fluid-content/utils/fluid-instrumentation-service';
import { ActivityReason } from '../../mru/models/activity-description.model';
import { AddMruItemEvent, ChangePinStateEvent, RemoveMruItemEvent } from '../../mru/models/mru-state-event.model';
import { ThumbnailInstrumentationService } from '../../mru/thumbnails/thumbnail-instrumentation.service';
import { PotentialActionType } from '../../officefeed/models/myanalytics.model';
import { OfficeFeedDataService } from '../../officefeed/officefeed-data.service';
import { ShareControlMode, ShareControlService } from '../../share-control/share-control.service';
import { UploadActionType, UploadLocalFileService } from '../../upload/upload-local-file/upload-local-file.service';
import { ActivityDescriptionService } from '../activity/activity-description.service';
import { BrandColor } from '../constants/brand-color.enum';
import { FabricConstants } from '../constants/fabric.constant';
import { LinkTarget } from '../constants/link-target.enum';
import { OfficeRoute } from '../constants/office-route.enum';
import { RoutePaths } from '../constants/route-paths.constant';
import { ActionsMenuComponent } from '../directives/actions-menu/actions-menu.component';
import { ResponsiveRelativeDatePipe } from '../directives/responsive-relative-date/responsive-relative-date.pipe';
import { IconFontType } from '../icon-font/icon-font-type.enum';
import { InstrumentationData } from '../instrumentation/instrumentation-data.model';
import { InstrumentationParam, InstrumentationParams, InstrumentationService, KnownAreas, KnownClickDestinations, KnownInstrumentationActions, KnownInstrumentationEvents, KnownReferralPlatform } from '../instrumentation/instrumentation.service';
import { ActionContextMenu } from '../models/action-context-menu.model';
import { ContextMenuItem } from '../models/context-menu-item.model';
import { AttachmentType } from '../models/email-attachment.model';
import { FileItem, FileType } from '../models/file-item.model';
import { FormEnum } from '../models/form.model';
import { ItemView } from '../models/item-view.model';
import { KnownWorkloadReferralNames } from '../models/known-workload-referral-names.model';
import { Menu } from '../models/menu.model';
import { ObservableScope } from '../models/observable-scope.enum';
import { PaintMarkerName } from '../models/paint-marker-name.enum';
import { Workload } from '../models/workload.model';
import { ActionType } from '../mru/activity.model';
import { MruConfigService } from '../mru/mru-config.service';
import { toMruDataItem } from '../mru/mru-data-converter.utility';
import { MruDataService } from '../mru/mru-data.service';
import { MruFileFormat, MruFileItem } from '../mru/mru-file-item.model';
import { AccessTokenService } from '../services/access-token.service';
import { DateService } from '../services/date.service';
import { DeviceDetector } from '../services/device-detector.service';
import { DocumentService } from '../services/document.service';
import { EventService } from '../services/event.service';
import { FloodgateService } from '../services/floodgate.service';
import { LocalAppLauncherService } from '../services/local-app-launcher.service';
import { OfficeRouteService } from '../services/office-route.service';
import { OneDriveService } from '../services/onedrive.service';
import { OneNoteService } from '../services/onenote.service';
import { PerformanceService } from '../services/performance.service';
import { UiHostBootstrapperService } from '../services/ui-host-bootstrapper.service';
import { LaunchAction, UrlLauncherService } from '../services/url-launcher.service';
import { WacContentService } from '../services/wac-content.service';
import { WindowService } from '../services/window.service';
import { FirstPartyWorkloadIds, WorkloadsService } from '../services/workloads.service';
import { AngularEvents } from '../shared-context/angular-events';
import { CapabilitiesService } from '../shared-context/capabilities.service';
import { AuthType, ClientStartupConfigService } from '../shared-context/client-startup-config.service';
import { ContextService } from '../shared-context/context.service';
import { LocService } from '../shared-context/loc.service';
import { isVideoFiletype } from '../utilities/file-item.utility';
import { GuidGenerator } from '../utilities/guid-generator.utility';
import { KeyboardKey, KeystrokeHandler } from '../utilities/keystroke-handler.utility';
import { PathArrayFormatter } from '../utilities/path-array-formatter.utility';
import { UrlBuilder } from '../utilities/url-builder.utility';
import { OfficeDotComOrigin, OfficeDotComPrvOrigin, WdOriginType } from './../models/telemetry-constants.model';
import { OfficeRouteItem } from './../services/office-route.service';
import { ContentActionsService } from './content-actions/content-actions.service';
import { MruItemInflationService } from './mru-item-inflation.service';
import { MruAdditionalContextMenuItem, MruItemService } from './mru-item.service';

export const enum MruItemStates {
    Loading,
    Resting,
    Remove,
    Moving
}

export const enum MruMyAItemStates {
    Added,
    Done,
    View
}

export interface CategoryIcon {
    categoryIcon?: string;
    categoryFontIcon?: IconFontType;
    categoryFontIconCssClass?: string;
    categoryFontIconColor?: string;
    categoryAriaLabel?: string;
    categoryTooltip?: string;
}

interface ApplicationSpecificData {
    iconFontClass: string;
    iconFontColor: BrandColor;
    // URI scheme for opening in native app or null if no native client exists
    nativeUriScheme?: string;
}

const enum UICardType {
    Normal = 'normal',
    BorderLess = 'borderless'
}

@Component({
    selector: 'ohp-mru-item',
    templateUrl: './mru-item.component.html',
    animations: [
        trigger('fadeInIsNew', [
            transition('inactive => active', [
                style({ opacity: 0 }),
                animate('500ms 0ms linear', style({ opacity: 1 }))
            ])
        ]),
        trigger('recommendedCardHover', [
            state('hovered', style({
                transform: 'scale(1.05)'
            })),
            transition('* => hovered', animate('100ms linear'))
        ])
    ],
    providers: [MruItemService]
})
export class MruItemComponent implements OnChanges, OnInit, OnDestroy {
    @Input() public item: MruFileItem;

    @Input() public index: number;

    @Input() public relativeIndex: number;

    @Input() public view: ItemView;

    @Input() public listId: string;

    @Input() public focusOnLoad: boolean;

    @Input() public showActivity: boolean;

    @Input() public showSharing: boolean;

    @Input() public showAnalytics: boolean;

    // File type of entire MRU component.
    @Input() public mruAppType: FileType;

    @Input() public leftAlignActionsMenu?: boolean = false;

    @Output() public readonly addItem: EventEmitter<AddMruItemEvent>;

    @Output() public readonly deleteItem: EventEmitter<RemoveMruItemEvent>;

    @Output() public readonly changePinState: EventEmitter<ChangePinStateEvent>;

    @ViewChild('titleElement') public titleElement: ElementRef;
    @ViewChild('mruListItem') public mruListItem: ElementRef;
    @ViewChild('fileIconElement') public fileIconElement: ElementRef;
    @ViewChild('attributionElement') public attributionElement: ElementRef;
    @ViewChild('timestampElement') public timestampElement: ElementRef;
    @ViewChild('shareControl') public shareControl: ElementRef;
    @ViewChild('shareTopLevel') public shareTopLevelElement: ElementRef;
    @ViewChild('myAnalyticsAddToDoLink') public myAnalyticsAddToDoElement: ElementRef;
    @ViewChild('myAnalyticsTaskDoneLink') public myAnalyticsTaskDoneElement: ElementRef;
    @ViewChild(ActionsMenuComponent) public actionsMenuElement: ActionsMenuComponent;

    public static isFirstClick: boolean;

    public ShareControlMode = ShareControlMode;
    public PotentialActionType = PotentialActionType;

    public isFormResponsesEnabled: boolean;
    public shortDate: boolean;
    public displayTime: Date;
    public displayTimeString: string;
    public showActionsMenu: boolean;
    public clickableFolderEnabled: boolean;
    public sharedText: string;
    public privateText: string;
    public activityEnabled: boolean;
    public permissionsEnabled: boolean;
    public shortPath: string;
    public showDesktopShareControl: boolean;
    public shareControlEnabled: boolean;
    public copyLinkEnabled: boolean;
    public thumbnailSWEnabled: boolean;
    public thumbnailLoaded: boolean;
    public actionsMenuOpen: boolean;
    public isNew: boolean;
    public isNewTitle: string;
    public isMobile: boolean;
    public isTouch: boolean;
    public descriptiveAriaLabel: string;
    public shareActionTitle: string;
    public copyLinkActionTitle: string;
    public uploadLocalFileTitle: string;
    public suggestedActionsReplyTitle: string;
    public suggestedActionsMeetingTitle: string;
    public suggestedActionsViewChangesTitle: string;
    public suggestedActionsAddToToDoTitle: string;
    public suggestedActionsViewTaskTitle: string;
    public contextMenu: Menu<ContextMenuItem>;
    public itemFocused: boolean;
    public instrumentationArea: string;
    public isRecommended: boolean;
    public mruAppSuffix: string;
    public showOnlyMruActivity: boolean;
    public mruActivity: boolean;
    public openFolderAriaLabel: string;
    public saveAClassNotebook: string;
    public thumbnailUrl: string;
    public dataSecurityThreshold: DataSecurityLevel;
    public showMobileShareAndActivity: boolean;
    public shareControlMode: ShareControlMode;
    public shareControlOutputs = {
        dismiss: () => this.onShareControlDismiss(true)
    };
    public url: string;
    public activityDeepLink: string;
    public recommendedDeepLinkEnabled: boolean;
    public teamsDeepLink: string;
    public recommendedTeamsLinkEnabled: boolean;
    public isOfficeFeed: boolean;
    public isNewsArticle: boolean;
    public isUpcomingMeeting: boolean;
    public isUpcomingMeetingAccepted: boolean;
    public isMyAnalytics: boolean;
    public uiCardType: UICardType;
    public isCardCreateByLabel: boolean;
    public isCardSharedByLabel: boolean;
    public borderlessCardDetail1: string;
    public thumbnailAltText: string;
    public isStreamsVideo: boolean;
    public streamsVideoThumbnail: Promise<string>;
    public thumbnail: Promise<string>;
    public isNewAnimationState: 'active' | 'inactive';
    public isHovered: 'hovered' | 'unhovered';
    public dismissIsHover: boolean;
    public recommendedMotion: boolean;
    public recommendedNewCards: boolean;
    public primaryAction: ContextMenuItem | DocumentAction;
    public primaryActionIconFont: IconFontType;
    public fluentRefresh: boolean;
    public centerThumbnail: boolean;
    public showListSvg: boolean;
    public showMeetingSvg: boolean;
    public showReplySvg: boolean;
    public workloadColorPromise: Promise<string>;
    public dismissItemTitle: string;

    public dismissSquareRegular: SafeHtml;
    public dismissSquareFilled: SafeHtml;
    public checklistIcon: SafeHtml;
    public meetingIcon: SafeHtml;
    public replyIcon: SafeHtml;

    public categoryIcon: CategoryIcon;
    public formEnumType: FormEnum;
    public collectionsSubMenuModel: Menu;

    private shareControlClickListener: Function;
    private shareControlTouchListener: Function;
    private shareControlKeyListener: Function;
    private shareControlLoading: boolean;
    private shareControlKeyboardFocus: boolean;
    private currentShareSource: 'topLevel' | 'menu' | '';
    private dateSubscription: Subscription;
    private uploadAndOpen: string;
    private inflationPromise: Promise<MruFileItem>;
    private analyticsDescriptiveAriaLabel: string;
    private leftNavEnabled: boolean;
    private workloadsPromise: Promise<Array<Workload>>;

    private plainTextPath: string;

    private readonly mobileMenusEnabled: boolean;
    private readonly isConsumer: boolean;
    private readonly downloadActionEnabled: boolean;

    private static applicationConversionMap: Map<FileType, ApplicationSpecificData>;
    private static readonly shortPathCharacterLimit = 25;
    private static readonly actionsMenuCssClass = 'actions-menu';

    // From this API call: https://microsoft-my.sharepoint-df.com/_api/v2.0/drive/commands
    // Not exposed via graph yet
    // May need to update periodically
    private static readonly acceptedThumbnailExtensions = ['flac', 'm4a', 'mp3', 'opus', 'wma', 'dwg', 'cool', 'fbx', 'glb', 'obj', 'ply', 'stl', '3mf', 'dcm', 'dcm30', 'dic', 'dicm', 'dicom', 'epub', 'htm', 'html', 'eml', 'msg', 'md', 'markdown', 'cur', 'ico', 'icon', 'mat', 'pict', 'psb', 'psd', 'webp', 'xbm', 'xcf', 'xpm', 'txt', 'bas', 'bash', 'bat', 'c', 'cbl', 'cfg', 'cmd', 'cpp', 'cs', 'css', 'csv', 'h', 'java', 'js', 'json', 'log', 'php', 'pl', 'ps1', 'py', 'rb', 'sh', 'sql', 'vb', 'xaml', 'yaml', 'yml', 'key', 'numbers', 'pages', 'sketch', 'xd', 'doc', 'docx', 'dot', 'dotx', 'dotm', 'odt', 'rtf', 'ods', 'xls', 'xlsb', 'xlsm', 'xlsx', 'xltx', 'odp', 'ppt', 'pptx', 'pptm', 'pot', 'potx', 'potm', 'pps', 'ppsx', 'ppsxm', 'pano', 'fppx', 'hcp', 'ai', 'epdf', 'pdf', 'pdfa', 'mts', 'm2ts', 'ts', '3g2', '3gp', '3gp2', '3gpp', 'asf', 'wmv', 'avi', 'm4v', 'mov', 'mp4', 'mp4v', 'ogg', 'webm', 'movie', 'mkv', 'mpg', 'mpeg', 'bmp', 'dib', 'rle', 'gif', 'jpeg', 'jpe', 'jpg', 'jfif', 'exif', 'png', 'tiff', 'tif', 'dng', 'wdp', 'jxr', 'hdp', 'dds', 'heic', 'heif', 'avci', 'heics', 'heifs', 'avcs', 'arw', 'cr2', 'crw', 'erf', 'kdc', 'mrw', 'nef', 'nrw', 'orf', 'pef', 'raf', 'raw', 'rw2', 'rwl', 'sr2', 'srw', '3fr', 'ari', 'bay', 'cap', 'cr3', 'dcs', 'dcr', 'drf', 'eip', 'fff', 'iiq', 'k25', 'mef', 'mos', 'ori', 'ptx', 'pxn', 'srf', 'x3f'];

    public mruItemState: MruItemStates;
    public readonly MRU_ITEM_LOADING_STATE: MruItemStates = MruItemStates.Loading;
    public mruItemStateSubscription: Subscription;
    public disableFileNavigation: boolean;
    public streamsThumbnailLoaded: boolean;

    public upcomingMeetingAttendeeDisplayMax: number;

    public wacHostHoverPrebootEnabled: boolean;
    public thumbnailApiEnabled: boolean;
    public isMicrosoftForms: boolean;

    // MyAnalytics strings
    public addToToDoText: string;
    public doneText: string;
    public notATaskText: string;
    public viewInToDoText: string;

    public myAnalyticsState: MruMyAItemStates;
    public readonly MYA_ITEM_VIEW_STATE: MruMyAItemStates = MruMyAItemStates.View;
    public readonly MYA_ITEM_ADDED_STATE: MruMyAItemStates = MruMyAItemStates.Added;

    // ActionContextMenu
    public actionContextMenuEnabled: boolean;
    public actionContextMenu: ActionContextMenu;

    // Pin action
    public mruPinEnabled: boolean;
    private readonly replacePinActionEnabled: boolean;
    public pinActionTitle: string;
    public unpinActionTitle: string;
    private pinActionId: string;
    private unpinActionId: string;
    public pinActionIcon: string;
    public unpinActionIcon: string;
    private pinActionIconReact?: ContentActionIcon;
    private unpinActionIconReact?: ContentActionIcon;
    private pinAction: ContextMenuItem | DocumentAction;
    private unpinAction: ContextMenuItem | DocumentAction;

    private readonly isPwa: boolean;

    constructor(
        private readonly activityDescriptionService: ActivityDescriptionService,
        private readonly capabilitiesService: CapabilitiesService,
        private readonly clientStartupConfigService: ClientStartupConfigService,
        private readonly contentActionsService: ContentActionsService,
        private readonly contextService: ContextService,
        private readonly dateService: DateService,
        private readonly deviceDetector: DeviceDetector,
        private readonly documentService: DocumentService,
        private readonly domSanitizer: DomSanitizer,
        private readonly eventService: EventService,
        private readonly instrumentationService: InstrumentationService,
        private readonly localAppLauncherService: LocalAppLauncherService,
        private readonly locService: LocService,
        private readonly mruConfigService: MruConfigService,
        private readonly mruItemInflationService: MruItemInflationService,
        private readonly mruItemService: MruItemService,
        private readonly officeFeedService: OfficeFeedDataService,
        private readonly officeRouteService: OfficeRouteService,
        private readonly oneDriveService: OneDriveService,
        private readonly onenoteService: OneNoteService,
        private readonly performanceService: PerformanceService,
        private readonly renderer: Renderer2,
        private readonly responsiveRelativeDatePipe: ResponsiveRelativeDatePipe,
        private readonly shareControlService: ShareControlService,
        private readonly thumbnailInstrumentationService: ThumbnailInstrumentationService,
        private readonly uploadLocalFileService: UploadLocalFileService,
        private readonly urlLauncherService: UrlLauncherService,
        private readonly uiHostBootstrapperService: UiHostBootstrapperService,
        private readonly wacContentService: WacContentService,
        private readonly windowService: WindowService,
        private readonly workloadsService: WorkloadsService,
        private readonly mruDataService: MruDataService,
        private readonly fluidHostContext: FluidHostContext,
        private readonly fluidInstrumentationService: FluidInstrumentationService,
        private readonly accessTokenService: AccessTokenService,
        private readonly floodgateService: FloodgateService
    ) {
        this.addItem = new EventEmitter<AddMruItemEvent>();
        this.deleteItem = new EventEmitter<RemoveMruItemEvent>();
        this.changePinState = new EventEmitter<ChangePinStateEvent>();
        const mruConfig = this.mruConfigService.config;
        this.activityEnabled = mruConfig.activityEnabled;
        this.mobileMenusEnabled = this.capabilitiesService.capabilities.mobileContextMenusEnabled;
        this.isConsumer = this.clientStartupConfigService.config.authType === AuthType.MSA;
        this.thumbnailApiEnabled = this.capabilitiesService.capabilities.thumbnailEndpointEnabled;
        this.actionContextMenuEnabled = this.capabilitiesService.capabilities.contentActionsEnabled && this.capabilitiesService.capabilities.contentActionsOHomeEnabled;
        this.downloadActionEnabled = this.capabilitiesService.capabilities.downloadActionEnabled;
        this.replacePinActionEnabled = this.capabilitiesService.capabilities.replacePinActionEnabled;
        this.isPwa = this.capabilitiesService.capabilities.isPwaInUwp;

        if (!MruItemComponent.applicationConversionMap) {
            MruItemComponent.applicationConversionMap = new Map<FileType, ApplicationSpecificData>();
            // for nativeUriScheme, 'ofe' means 'Open for Edit' and tells the native app to open in edit mode instead of read-only. For Excel, 'ofc' means 'Open for CoAuth', but falls back to
            // 'ofv' (Open for View) if CoAuth is not supported.
            MruItemComponent.applicationConversionMap.set(FileType.Word, { iconFontClass: mruConfig.wordIconFontClass, iconFontColor: BrandColor.Word, nativeUriScheme: 'ms-word:ofe|u|' });
            MruItemComponent.applicationConversionMap.set(FileType.Excel, { iconFontClass: mruConfig.excelIconFontClass, iconFontColor: BrandColor.Excel, nativeUriScheme: 'ms-excel:ofv|ofc|u|' });
            MruItemComponent.applicationConversionMap.set(FileType.Visio, { iconFontClass: mruConfig.visioIconFontClass, iconFontColor: BrandColor.Visio, nativeUriScheme: 'ms-visio:ofe|u|' });
            MruItemComponent.applicationConversionMap.set(FileType.PowerPoint, { iconFontClass: mruConfig.powerPointIconFontClass, iconFontColor: BrandColor.PowerPoint, nativeUriScheme: 'ms-powerpoint:ofe|u|' });
            // Todo: Add Projects and roadmaps to launcheable from win32 apps if supported
            // MruItemComponent.applicationConversionMap.set(FileType.Project, { iconFontClass: icons.get(this.workloadsService.getWorkloadId(FileType.Project)), iconFontColor: BrandColor.Project, nativeUriScheme: 'ms-project:ofe|u|' });
            // MruItemComponent.applicationConversionMap.set(FileType.Portfolio, { iconFontClass: icons.get(this.workloadsService.getWorkloadId(FileType.Portfolio)), iconFontColor: BrandColor.Project, nativeUriScheme: 'ms-project:ofe|u|' });
            MruItemComponent.applicationConversionMap.set(FileType.OneNote, { iconFontClass: mruConfig.oneNoteIconFontClass, iconFontColor: BrandColor.OneNote, nativeUriScheme: 'onenote:' });
            MruItemComponent.applicationConversionMap.set(FileType.Sway, { iconFontClass: mruConfig.swayIconFontClass, iconFontColor: BrandColor.Sway });
            MruItemComponent.applicationConversionMap.set(FileType.Forms, { iconFontClass: mruConfig.formsIconFontClass, iconFontColor: BrandColor.Forms });
            MruItemComponent.applicationConversionMap.set(FileType.PowerBI, { iconFontClass: mruConfig.powerBIIconFontClass, iconFontColor: BrandColor.PowerBI });
            // FileType.Stream is for Stream 2.0 (ODSP) videos and FileType.StreamsVideo is for Stream Classic portal
            MruItemComponent.applicationConversionMap.set(FileType.Stream, { iconFontClass: mruConfig.streamIconFontClass, iconFontColor: BrandColor.Stream });
            MruItemComponent.applicationConversionMap.set(FileType.StreamsVideo, { iconFontClass: mruConfig.streamIconFontClass, iconFontColor: BrandColor.Stream });
        }
    }

    public ngOnInit() {
        this.fluentRefresh = this.capabilitiesService.capabilities.fluentRefresh;
        this.isMicrosoftForms = this.item.fileType === FileType.Forms || this.item.fileType === FileType.FormsQuiz;
        this.disableFileNavigation = this.item.isDeleted;
        this.mruItemStateSubscription = this.eventService.events.withScope(ObservableScope.PastAndFuture).pipe(filter(event => event.name === AngularEvents.mruItemStateChange)).subscribe(event => {
            if ((event.args[1] as MruFileItem).docId === this.item.docId) {
                if (event.args[0] === MruItemStates.Loading || event.args[0] === MruItemStates.Resting) {
                    this.mruItemState = event.args[0];
                }
            }
        });
        this.myAnalyticsState = MruMyAItemStates.View;
        this.uiCardType = this.isMicrosoftForms ? UICardType.BorderLess : UICardType.Normal;
        this.isCardCreateByLabel = this.isMicrosoftForms;
        const mruConfig = this.mruConfigService.config;
        const shortDateWidth = FabricConstants.MediumScreenMaxWidth;
        this.shortDate = this.windowService.innerWidth < shortDateWidth;
        if (this.locService.supportsLocaleSpecifiers) {
            this.dateSubscription = this.eventService.events.withScope(ObservableScope.OnlyFuture).pipe(
                filter(event => event.name === AngularEvents.contentWidthChanged))
                .subscribe(event => {
                    let newWidth: number;
                    [newWidth] = event.args;
                    this.shortDate = newWidth < shortDateWidth;
                });
        }
        this.thumbnailSWEnabled = mruConfig.thumbnailSWEnabled;
        this.permissionsEnabled = mruConfig.permissionsEnabled;
        this.sharedText = this.locService.SharedText;
        this.privateText = this.locService.OnlyYouText;
        this.shareActionTitle = this.locService.ShareActionTitle;
        this.copyLinkActionTitle = this.locService.CopyLinkActionTitle;
        this.suggestedActionsReplyTitle = this.locService.SuggestedActionReply;
        this.suggestedActionsMeetingTitle = this.locService.SuggestedActionJoinMeeting;
        this.suggestedActionsViewChangesTitle = this.locService.SuggestedActionViewChanges;
        this.suggestedActionsAddToToDoTitle = this.locService.AddToToDo;
        this.suggestedActionsViewTaskTitle = this.locService.SuggestedActionViewTask;
        // eslint-disable-next-line @microsoft/sdl/no-angular-bypass-sanitizer
        this.dismissSquareRegular = this.domSanitizer.bypassSecurityTrustHtml(dismissSquareSvgRegular as string);
        // eslint-disable-next-line @microsoft/sdl/no-angular-bypass-sanitizer
        this.dismissSquareFilled = this.domSanitizer.bypassSecurityTrustHtml(dismissSquareSvgFilled as string);
        // eslint-disable-next-line @microsoft/sdl/no-angular-bypass-sanitizer
        this.checklistIcon = this.domSanitizer.bypassSecurityTrustHtml(checklistSvg as string);
        // eslint-disable-next-line @microsoft/sdl/no-angular-bypass-sanitizer
        this.meetingIcon = this.domSanitizer.bypassSecurityTrustHtml(meetingSvg as string);
        // eslint-disable-next-line @microsoft/sdl/no-angular-bypass-sanitizer
        this.replyIcon = this.domSanitizer.bypassSecurityTrustHtml(replySvg as string);
        this.saveAClassNotebook = this.locService.SaveAClassNotebook;
        this.uploadLocalFileTitle = this.locService.UploadToOneDriveTitle;
        this.uploadAndOpen = this.locService.PwaUploadAndOpenMenuItem;
        this.isMobile = this.deviceDetector.isMobileDevice();
        this.isTouch = this.isMobile || this.deviceDetector.isTabletDevice();
        this.showMobileShareAndActivity = this.mruConfigService.config.mobileShareAndActivityEnabled;
        // TODO: Use FileFormat.Recommended and move to initializeItemFeatures() once we get rid of the trending recommended service
        this.showOnlyMruActivity = this.item.format === MruFileFormat.Recent && this.mruConfigService.config.onlyMruActivityEnabled;
        this.mruActivity = this.mruConfigService.config.mruActivityEnabled;
        this.recommendedDeepLinkEnabled = this.capabilitiesService.capabilities.recommendedDeepLinkEnabled;
        this.recommendedTeamsLinkEnabled = this.capabilitiesService.capabilities.recommendedTeamsLinkEnabled;
        this.recommendedMotion = mruConfig.recommendedMotionEnabled && !this.fluentRefresh;
        this.recommendedNewCards = mruConfig.recommendedNewCardsEnabled;
        this.isStreamsVideo = this.item.format === MruFileFormat.StreamsVideo;
        this.leftNavEnabled = this.capabilitiesService.capabilities.leftNavReact;
        this.wacHostHoverPrebootEnabled = this.capabilitiesService.wacHostEnabledForFileType(this.item.fileType) && this.capabilitiesService.wacHostHoverPrebootEnabledForFileType(this.item.fileType);
        this.dismissItemTitle = this.locService.RemoveDocumentActionTitle;
        this.isNewTitle = this.locService.IsNewTitle;
        this.centerThumbnail = this.item.fileType === FileType.PowerPoint;

        this.mruAppSuffix = this.mruAppType ? `-${FileType[this.mruAppType].toLowerCase()}` : '';

        this.upcomingMeetingAttendeeDisplayMax = mruConfig.upcomingMeetingAttendeeDisplayMax;
        this.isUpcomingMeetingAccepted = this.item.isUpcomingMeetingAccepted;

        // MyAnalytics strings
        this.addToToDoText = this.locService.AddToToDo;
        this.viewInToDoText = this.locService.ViewInToDo;
        this.doneText = this.locService.Done;
        this.notATaskText = this.locService.NotATask;

        // Pin action
        this.pinActionTitle = this.locService.PinDocumentActionTitle;
        this.unpinActionTitle = this.locService.UnpinDocumentActionTitle;
        this.pinActionId = 'pin_menu';
        this.unpinActionId = 'unpin_menu';
        this.pinActionIcon = 'PinDown';
        this.unpinActionIcon = 'Unpin';
        if (this.replacePinActionEnabled) {
            this.pinActionTitle = this.locService.FavoriteActionTitle;
            this.unpinActionTitle = this.locService.UnfavoriteActionTitle;
            this.pinActionIcon = 'FavoriteStar';
            this.unpinActionIcon = 'Unfavorite';
        }
        if (this.actionContextMenuEnabled) {
            if (this.replacePinActionEnabled) {
                this.pinActionId = 'Favorite';
                this.unpinActionId = 'Unfavorite';
                this.pinActionIconReact = {
                    type: ActionContextMenuItemIcon.ActionContextMenuIcon,
                    iconName: 'StarIcon'
                };
                this.unpinActionIconReact = {
                    type: ActionContextMenuItemIcon.ActionContextMenuIcon,
                    iconName: 'StarOffIcon'
                };
            } else {
                this.pinActionId = 'pin';
                this.unpinActionId = 'unpin';
                this.pinActionIconReact = {
                    type: ActionContextMenuItemIcon.ActionContextMenuIcon,
                    iconName: 'PinIcon'
                };
                this.unpinActionIconReact = {
                    type: ActionContextMenuItemIcon.ActionContextMenuIcon,
                    iconName: 'UnpinIcon'
                };
            }
        }

        this.workloadsPromise = this.workloadsService.getWorkloads();
        this.workloadColorPromise = this.workloadsPromise.then(workloads => workloads?.find(workload => workload.FileType === this.item.fileType)?.Color || '');

        this.initializeItemFeatures();
    }

    public ngOnChanges(changes: SimpleChanges) {
        // Check if only item is being changed to make sure we only re-initialize the @Input() item-specific component properties features when SW refreshes MRU at runtime:
        // - On initialization, all inputs are changed.
        // - In pin / unpin scenario, only index gets changed
        // - When SW updates its MRU cache, only item gets changed
        // - If recommended, index gets changed when navigating forward/back but we want to update actions menu
        if (changes.hasOwnProperty('item') && (!changes.hasOwnProperty('index') || this.isRecommended || this.isOfficeFeed)) {
            this.initializeItemFeatures();
            this.isStreamsVideo = this.item.format === MruFileFormat.StreamsVideo;
            this.thumbnailAltText = this.createThumbnailAltText(this.item.fileType);
        }

        // Make sure this doesn't trigger thumbnail inflation on initial load. If on initial view the user is on tile view,
        // then the initial inflation process triggered in initializeItemFeatures() will fetch thumbnails along with other data.
        // Recommended items always get thumbnails during inflation so skip this for those items.
        if (changes.hasOwnProperty('view') && !changes.view.firstChange &&
            (changes.view.currentValue === ItemView.Tile || changes.view.currentValue === ItemView.Card) && !this.isRecommended && !this.isOfficeFeed) {
            if (!this.thumbnailLoaded && !this.thumbnailUrl) {
                this.mruItemInflationService.inflateThumbnails(this.item).then(() => {
                    this.thumbnailUrl = this.getThumbnailUrl();
                    this.onThumbnailLoad();
                    this.thumbnailAltText = this.createThumbnailAltText(this.item.fileType);
                });
            }
        }
    }

    public ngOnDestroy() {
        if (this.dateSubscription) {
            this.dateSubscription.unsubscribe();
        }

        if (this.mruItemStateSubscription) {
            this.mruItemStateSubscription.unsubscribe();
        }

        this.removeShareControlListeners();
    }

    public showAsListItem() {
        return (typeof this.view === 'undefined') || this.view === ItemView.List;
    }

    public showAsTile() {
        return this.view === ItemView.Tile && this.item.format !== MruFileFormat.Trending;
    }

    public showAsCard() {
        return this.view === ItemView.Card || (this.view === ItemView.Tile && this.item.format === MruFileFormat.Trending);
    }

    public showAsSuggestedAction() {
        return this.capabilitiesService.capabilities.suggestedActionsEnabled && this.view === ItemView.SuggestedAction;
    }

    public iconFontClass(): string {
        const applicationSpecificIconData = MruItemComponent.applicationConversionMap.get(this.item.fileType);
        if (!applicationSpecificIconData) {
            return null;
        }

        return applicationSpecificIconData.iconFontClass;
    }

    public iconFontColor(): BrandColor {
        const applicationSpecificIconData = MruItemComponent.applicationConversionMap.get(this.item.fileType);
        if (!applicationSpecificIconData) {
            return null;
        }

        return applicationSpecificIconData.iconFontColor;
    }

    // Captures exactly which element was clicked to open the MRU item and logs a click event.
    public onItemClick(event: Event) {
        if (this.disableFileNavigation) {
            event.preventDefault();
            return;
        }
        if (event.defaultPrevented) {
            return;
        }
        if (this.isOfficeFeed) {
            this.officeFeedService.logInstrumentation([this.item.feedbackId], ['click'], [this.item.fromCache ? 'cache' : 'service']);
        }

        event.preventDefault();

        const [launchUrl, clickId] = this.getLaunchUrlAndClickId(this.url);

        const clickData = this.getClickData(event);
        const clickTargetId = clickData.params[InstrumentationParam.ElementId] as string || 'Unknown';

        if (clickId) {
            clickData.params[InstrumentationParam.RequestId] = clickId; // Use this Id to correlate with WAC in case there is an error opening a document.
        }

        clickData.params[InstrumentationParam.IsEmailAttachment] = this.item.isEmailAttachment ? 'true' : 'false';
        clickData.params[InstrumentationParam.IsOnPremOrVanity] = this.item.isOnPremOrVanity ? 'true' : 'false';

        let clickLogged = false;
        const logClick = (success: boolean, platform?: KnownReferralPlatform, nav?: boolean, uiHost?: boolean) => {
            if (clickLogged) {
                return;
            }
            clickLogged = true;
            const clickReferral = success ? (clickData.params[InstrumentationParam.Referral] as string) : '';

            if (uiHost) {
                clickData.params[InstrumentationParam.ClickDestination] = KnownClickDestinations.ContentPage;
            }

            this.instrumentationService
                .logClickEvent(clickData.eventName, clickTargetId, this.instrumentationArea, clickReferral, platform, clickData.params, clickData.metrics, this.dataSecurityThreshold, nav);
            logUserAction({
                eventName: clickData.eventName,
                id: clickTargetId,
                area: this.instrumentationArea as Area,
                subArea: 'Document',
                result: clickReferral ? 'Refer' : 'Navigate',
                target: clickReferral ? getReferral(clickReferral) : 'Other'
            }, this.dataSecurityThreshold as unknown as OtelDataSecurityLevel);

            // If this is first item click since MRU paint, also log perf marker for time elapsed between the 2 events.
            if (MruItemComponent.isFirstClick && !this.isRecommended) {
                const mruPaintMarkerPrefix = `Paint_${PaintMarkerName.MRU}`;
                const paintMarker = this.performanceService.getRecordedMarkerNameBySubstring(mruPaintMarkerPrefix);
                if (paintMarker) {
                    this.performanceService.mark('MRU_First_ItemClick', paintMarker);
                }
                MruItemComponent.isFirstClick = false;
            }
        };

        // Only wait to log click if we open in a new tab, otherwise we risk losing the event
        if (this.contextService.sharedContext.defaultLinkTarget !== LinkTarget.NewTab) {
            logClick(true, KnownReferralPlatform.Web);
        }
        const wacHostFile = this.capabilitiesService.wacHostEnabledForFileType(this.item.fileType);
        const fluidHostFile = this.capabilitiesService.capabilities.fluidSupportEnabled && this.item.fileType === FileType.Fluid;
        const linkTarget = FileType.Forms === this.item.fileType ? LinkTarget.SameFrame : LinkTarget.NewTab;
        const openWebApp = () => {
            // Check if file is supported by wac, isn't a vanity file, and we have the necessary tokens
            const hasTokenForWacHost = ((!this.item.isOnPremOrVanity || this.isConsumer) && this.accessTokenService.hasOneDriveToken())
                || this.contextService.sharedContext.inMockMode;
            // Check if Fluid File
            if ((wacHostFile && hasTokenForWacHost) || fluidHostFile) {
                if (event['ctrlKey']) {
                    const newPath = `/${RoutePaths.ContentHost.replace(':app', FileType[this.item.fileType])}`;
                    const itemUrl = UrlBuilder.replacePathAndAddParams(
                        this.windowService.nativeWindow.location.href,
                        newPath,
                        WacContentService.getParamsForMruFileItem(
                            this.item,
                            fluidHostFile ? { siteUrl: this.item.sharepointIds.siteUrl } : {}
                        )
                    );
                    this.urlLauncherService.openUrl(itemUrl, LaunchAction.OpenMruItem, linkTarget).then(() => {
                        logClick(true, KnownReferralPlatform.Web);
                    }, () => {
                        logClick(false);
                    });
                } else {
                    const startTime = Date.now();
                    if (fluidHostFile) {
                        this.fluidInstrumentationService.logPerformanceBootStart(this.fluidHostContext.getBootId());
                        this.fluidHostContext.hostScenarioLifecycle = 'Load';
                        this.fluidHostContext.hostScenarioName = this.item.fileType === FileType.Fluid ? 'Canvas' : 'MeetingNotes';
                        this.fluidHostContext.hostScenarioEntryPoint = 'MRU';
                        this.fluidHostContext.hostScenarioStartTime = startTime;
                    }

                    logClick(true, KnownReferralPlatform.Web, true, true);
                    if (wacHostFile) {
                        this.wacContentService.bootstrapAndRouteMruFileItem(
                            this.item,
                            this.getWdOrigin(false),
                            undefined,
                            startTime,
                            this.inflationPromise
                        );
                    } else {
                        this.officeRouteService.navigateTo(
                            { route: OfficeRoute.Content, app: this.item.fileType },
                            false,
                            WacContentService.getParamsForMruFileItem(
                                this.item,
                                fluidHostFile ? { siteUrl: this.item.sharepointIds.siteUrl } : {}
                            )
                        );
                    }
                }
            } else {
                // Pdf documents are opened in the browser, so we manually write to the MRU here
                // Email attachments are opened in OWA viewer, which currently does not write to MRU
                if (this.item.fileType === FileType.Pdf && !this.item.isEmailAttachment) {
                    const mruDataItem = toMruDataItem(this.item);
                    if (this.isRecommended || this.isOfficeFeed) {
                        // GET requests from recommended come back with application "Pdf".  MRU uses application "PdfViewer"
                        // It also does not have an MruType, which for PDF is "DocumentUrl"
                        mruDataItem.Application = 'PdfViewer';
                        mruDataItem.MruV2Type = 'DocumentUrl';
                    }
                    this.mruDataService.writeMruDocument(mruDataItem);
                }

                // Fallback to webUrl if launchUrl is falsy (e.g. 3P content)
                const url = launchUrl || this.item.webUrl;
                if (this.capabilitiesService.capabilities.contentLauncherEnabled) {
                    import('@office-start/launcher-service').then(
                        launchSvc => {
                            launchSvc.launchUrl(url, { action: 'OpenMruItem', linkTarget: this.isMicrosoftForms ? '_self' : undefined }).then(() => {
                                logClick(true, KnownReferralPlatform.Web);
                            }, () => {
                                logClick(false);
                            });
                        }
                    );
                } else {
                    this.urlLauncherService.openUrl(url, LaunchAction.OpenMruItem, this.isMicrosoftForms ? LinkTarget.SameFrame : null).then(() => {
                        logClick(true, KnownReferralPlatform.Web);
                    }, () => {
                        logClick(false);
                    });
                }
            }
        };

        const launchContentHandler = () => {
            if (this.capabilitiesService.capabilities.contentLauncherEnabled) {
                const document = this.getOfficeStartDocument();

                import('@office-start/launcher-service').then(
                    launchSvc => {
                        launchSvc.launchContent(
                            {
                                action: 'OpenMruItem',
                                document,
                                linkTarget: (this.isPwa || (event && event['ctrlKey'])) ? '_blank' :  FileType.Forms === this.item.fileType || FileType.FormsQuiz === this.item.fileType ? '_self' : '_blank',
                                useWebUrl: true,
                                wdOriginType: WdOriginTypeInst.Recommended
                            }
                        ).then(() => {
                            logClick(true, KnownReferralPlatform.Web);
                        }, () => {
                            logClick(false);
                        });
                    }
                );
            } else {
                openWebApp();
            }
        };
        if (this.item.isEmailAttachment) {
            launchContentHandler();
        } else {
            if (this.capabilitiesService.capabilities.contentLauncherEnabled) {
                launchContentHandler();
            } else {
                // Launch native Office app to open local MRU files
                this.localAppLauncherService.launchOfficeApp(this.item.application, this.item.canonicalUrl, null)
                    .then(success => {
                        if (!success && !this.item.isLocal) {
                            openWebApp();
                            return true;
                        }
                        return success;
                    }).then(urlHandled => {
                        if (urlHandled) {
                            logClick(true, KnownReferralPlatform.Native);
                            return;
                        }
                        this.openUploadLocalModal(UploadActionType.Open);
                        logClick(false);
                    }).catch(() => {
                        openWebApp();
                    });
            }
        }

        if (this.officeRouteService.getCurrentRoute()?.route ===  OfficeRoute.OfficeHome) {
            this.floodgateService.recordFloodgate(['ClickedOnDocument']);
        }
    }

    public onPathClick(event: Event) {
        event.preventDefault();
        this.openFolder();
        const clickData = this.getAttributionClickData();
        const clickTargetId = clickData.params[InstrumentationParam.ElementId] as string || 'Unknown';
        // PWA TODO: What should this be for local explorer launches?
        const clickReferral = clickData.params[InstrumentationParam.Referral] as string;

        this.instrumentationService.logClickEvent(clickData.eventName, clickTargetId, this.instrumentationArea, clickReferral, this.item.isLocal ? KnownReferralPlatform.Native : KnownReferralPlatform.Web, clickData.params, clickData.metrics, this.dataSecurityThreshold);
        logUserAction({
            eventName: clickData.eventName,
            id: clickTargetId,
            area: this.instrumentationArea as Area,
            subArea: 'DocumentPath',
            result: clickReferral ? 'Refer' : 'Navigate',
            target: clickReferral ? getReferral(clickReferral) : 'Other'
        }, this.dataSecurityThreshold as unknown as OtelDataSecurityLevel);
    }

    public onMyAnalyticsClick(event: Event, action: PotentialActionType) {
        event.preventDefault();
        const clickData = this.getClickData(event);
        const clickTargetId = clickData.params[InstrumentationParam.ElementId] as string || 'Unknown';
        this.instrumentationService.logClickEvent(clickData.eventName, clickTargetId, this.instrumentationArea);

        // replace links based on click
        const clickTarget = event.target;

        this.officeFeedService.performAction(this.item.feedbackId, action, this.getActionPayLoadByName(action));

        // If Item was added, add View in To do as context menu item
        if (clickTarget === this.myAnalyticsAddToDoElement?.nativeElement) {
            this.myAnalyticsState = MruMyAItemStates.Added;

            // Add View in To Do
            if (this.actionContextMenuEnabled) {
                this.addToContextMenuReact(this.createViewInToDoActionItemReact());
                this.removeFromContextMenuReact(this.addToToDoText);
            } else {
                this.addToContextMenu(this.createViewInToDoActionItem());
                this.removeFromContextMenu(this.addToToDoText);
            }

            if (this.showAsSuggestedAction) {
                this.setViewInToDoAsPrimaryAction();
            }
        } else if (clickTarget === this.myAnalyticsTaskDoneElement?.nativeElement) {
            this.removeItem();
        }
    }

    public async onViewToDoClick(suggestedActionValue?: string) {
        const url = await this.getToDoUrl();
        const todoUrl = new URL(url);
        const todoInboxUrl = `${todoUrl.origin}${todoUrl.pathname}/inbox${todoUrl.search}`;
        if (this.capabilitiesService.capabilities.contentLauncherEnabled) {
            import('@office-start/launcher-service').then(
                launchSvc => {
                    launchSvc.launchUrl(todoInboxUrl, { action: 'OpenToDoLink' });
                }
            );
        } else {
            this.urlLauncherService.openUrl(todoInboxUrl, LaunchAction.OpenToDoLink);
        }
        this.instrumentAction('open', suggestedActionValue);

    }

    public disableClick() {
        event.preventDefault();
    }

    public onShareClick(event: Event, source: 'topLevel' | 'menu', mode: ShareControlMode) {
        if (event) {
            event.preventDefault();
        }

        if (this.item.isLocal) {
            this.openUploadLocalModal(UploadActionType.Share);
            return;
        }

        this.shareControlMode = mode;
        this.showDesktopShareControl = !this.mobileMenusEnabled;
        this.shareControlLoading = true;
        this.currentShareSource = source;

        if (this.showDesktopShareControl) {
            const shareControlClickHandler = (shareControlClickEvent: MouseEvent | TouchEvent) => {
                if (!this.shareControlLoading && this.showDesktopShareControl && !(shareControlClickEvent instanceof MouseEvent && shareControlClickEvent.button === 2)) {
                    if (this.shareControl.nativeElement.contains(shareControlClickEvent.target)) {
                        return;
                    }

                    this.onShareControlDismiss(false);
                }
            };

            const shareControlKeyboardHandler = (shareControlKeyboardEvent: KeyboardEvent) => {
                const key = KeystrokeHandler.getKey(shareControlKeyboardEvent);
                if (this.showDesktopShareControl && key === KeyboardKey.Escape) {
                    this.onShareControlDismiss(true);
                }
            };

            this.shareControlClickListener = this.renderer.listen(this.documentService.nativeDocument, 'click', shareControlClickHandler);
            this.shareControlTouchListener = this.renderer.listen(this.documentService.nativeDocument, 'touchend', shareControlClickHandler);
            this.shareControlKeyListener = this.renderer.listen(this.documentService.nativeDocument, 'keyup', shareControlKeyboardHandler);

            // This sets the loading flag to false asynchronously, which is needed to make sure
            // the click listener doesn't close the control when this menu item is clicked.
            setTimeout(() => this.shareControlLoading = false, 0);
        }

        if (this.mobileMenusEnabled) {
            this.shareControlKeyboardFocus = event instanceof KeyboardEvent;

            this.shareControlService.showControl({
                file: this.item,
                index: this.index,
                mode: this.shareControlMode
            });

            this.shareControlService.subscribeToCloseEvents(closeEvent => {
                if (this.item === closeEvent.file && this.index === closeEvent.index) {
                    this.onShareControlDismiss(this.shareControlKeyboardFocus);
                }
            });
        }

        this.instrumentAction(`${ShareControlMode[mode].toLowerCase()}_${source}`);
    }

    public onShareControlDismiss(focusOnShare: boolean) {
        this.showDesktopShareControl = false;
        this.removeShareControlListeners();
        if (focusOnShare) {
            this.focusOnShareAction();
        }

        this.currentShareSource = '';
    }

    public pinItem(event: Event, source: 'topLevel' | 'menu') {
        if (this.item.isLocal) {
            if (event) {
                event.preventDefault();
            }
            this.openUploadLocalModal(this.replacePinActionEnabled ? UploadActionType.Favorite : UploadActionType.Pin);
            return;
        }
        this.updatePinnedState(true, event, source);
    }

    public unpinItem(event: Event, source: 'topLevel' | 'menu') {
        this.updatePinnedState(false, event, source);
    }

    public onThumbnailLoad() {
        // Wait a tick to avoid a one-time devMode
        // unidirectional-data-flow-violation error
        setTimeout(() => {
            if (this.isStreamsVideo) {
                this.streamsThumbnailLoaded = true;
                this.thumbnailLoaded = false;
            } else {
                this.thumbnailLoaded = true;
                this.streamsThumbnailLoaded = false;
            }
        });

        this.thumbnailInstrumentationService.instrumentThumbnailLoad(true, this.thumbnailUrl, this.listId, this.index, this.item.fileType);
    }

    public onThumbnailError() {
        // Wait a tick to avoid a one-time devMode
        // unidirectional-data-flow-violation error
        setTimeout(() => {
            this.item.thumbnails = null;
            this.streamsThumbnailLoaded = false;
            this.thumbnailLoaded = false;
        });

        this.thumbnailInstrumentationService.instrumentThumbnailLoad(false, this.thumbnailUrl, this.listId, this.index, this.item.fileType);
    }

    public onActionsMenuToggle(open: boolean) {
        this.actionsMenuOpen = open;
        if (this.recommendedMotion) {
            this.isHovered = 'unhovered';
        }
    }

    public onFocus() {
        this.itemFocused = true;
    }

    public onBlur() {
        this.itemFocused = false;
    }

    public onAnalyticsDescriptionChanged(analyticsDescription: string) {
        this.analyticsDescriptiveAriaLabel = analyticsDescription;
        this.setDescriptiveAriaLabel();
    }

    public uploadLocal(event?: Event) {
        if (event) {
            event.preventDefault();
        }
        this.uploadLocalFileService.getLocalFileInfo(this.item.url, this.item.fileName).then(file => {
            this.uploadLocalFileService.uploadFile(file, 'upload-local-file-commanding');
        });
    }

    public recommendedHover(hover: 'hovered' | 'unhovered') {
        if (!this.actionsMenuOpen && this.recommendedMotion) {
            this.isHovered = hover;
        }
    }

    public dismissHover(hover: boolean) {
        this.dismissIsHover = hover;
    }

    public getWdOriginTaskForClick(openInBrowser = false): WdOriginType {
        const recommended = this.isRecommended || this.isOfficeFeed;
        if (recommended) {
            return openInBrowser ? WdOriginType.RecommendedOpenInBrowser : WdOriginType.Recommended;
        } else if (this.listId === 'unpinned-mru') {
            return openInBrowser ? WdOriginType.MruOpenInBrowser : WdOriginType.Mru;
        }

        return WdOriginType.Other;
    }

    public onSelectPrimaryAction(event: MouseEvent | KeyboardEvent) {
        if (event) {
            event.preventDefault();
            if ('id' in this.primaryAction) {
                this.primaryAction.executeAction();
            } else {
                this.primaryAction.executeAction(event);
            }
        }
    }

    public removeItem(event?: Event) {
        if (event) {
            event.preventDefault();
        }

        if (this.actionContextMenuEnabled) {
            this.runUnregisteredAction('remove', () => this.deleteItem.emit({ item: this.item, index: this.index }));
        } else {
            this.deleteItem.emit({ item: this.item, index: this.index });
            this.instrumentAction('remove');
        }
    }

    public suggestedActionsIcon(): string {
        return FileItem.documentIconFromType(this.item.fileType, '20x20');
    }

    private onSuggestedActionsClick(url: string, launchAction: LaunchAction, actionType: string, suggestedActionType: string, launchApp: boolean = false) {
        const launchUrl = () => {
            if (this.capabilitiesService.capabilities.contentLauncherEnabled) {
                import('@office-start/launcher-service').then(
                    launchSvc => {
                        launchSvc.launchUrl(url || this.url, { action: launchAction.toString() as LaunchActionReact });
                    }
                );
            } else {
                this.urlLauncherService.openUrl(url || this.url, launchAction); // if no deeplink given, use url
            }
            this.instrumentAction(actionType, suggestedActionType);
        };

        if (launchApp) {
            let launchAppPromise;
            if (this.capabilitiesService.capabilities.contentLauncherEnabled) {
                launchAppPromise = import('@office-start/launcher-service').then(launchSvc => launchSvc.launchApp({ action: 'OpenDocument', appName: this.item.application, url: url || this.item.canonicalUrl, useUrl: true }));
            } else {
                launchAppPromise = this.localAppLauncherService.launchOfficeApp(this.item.application, url || this.item.canonicalUrl, null);
            }
            launchAppPromise
                .then(success => {
                    if (!success) {
                        launchUrl();
                    } else {
                        this.instrumentAction('openInApp', suggestedActionType);
                    }
                }).catch(() => {
                    launchUrl();
                });
        } else {
            launchUrl();
        }
    }

    private addToContextMenu(item: ContextMenuItem, newIndex?: number) {
        if (!this.contextMenu) {
            return;
        }
        const index = this.contextMenu.items.findIndex(_ => _.getId() === item.getId());
        if (index === -1) {
            if (newIndex !== undefined && newIndex >= 0 && newIndex < this.contextMenu.items.length) {
                this.contextMenu.items.splice(newIndex, 0, item);
            } else {
                this.contextMenu.items.push(item);
            }
        }
    }

    private removeFromContextMenu(itemTitle: string) {
        const index = this.contextMenu.items.findIndex(_ => _.title === itemTitle);
        if (index !== -1) {
            this.contextMenu?.items?.splice(index, 1);
        }
    }

    private addToContextMenuReact(item: DocumentAction, newIndex?: number) {
        if (!this.actionContextMenu) {
            return;
        }
        const index = this.actionContextMenu.actions.findIndex(_ => _.id === item.id);
        if (index === -1) {
            if (newIndex !== undefined && newIndex >= 0 && newIndex < this.contextMenu.items.length) {
                this.actionContextMenu.actions = this.actionContextMenu.actions.slice(0, index).concat(item, this.actionContextMenu.actions.slice(index, this.actionContextMenu.actions.length));
            } else {
                this.actionContextMenu.actions = this.actionContextMenu.actions.concat(item);
            }
        }
    }

    private removeFromContextMenuReact(itemTitle: string) {
        const index = this.actionContextMenu.actions.findIndex(_ => _.title === itemTitle);
        if (index !== -1) {
            this.actionContextMenu.actions = this.actionContextMenu.actions.slice(0, index).concat(this.actionContextMenu.actions.slice(index + 1, this.actionContextMenu.actions.length));
        }
    }

    private getDisplayTime(): Date {
        if (this.item.format === MruFileFormat.Shared || this.item.format === MruFileFormat.SharedForm) {
            if (this.item.sharedTime > new Date('1980-01-01T00:00:00Z')) { // picked a date "eons ago" to make sure we don't show the default date
                return this.item.sharedTime;
            }
            return null;
        }

        if (this.item.format === MruFileFormat.Trending || this.item.format === MruFileFormat.ClassNoteBook || this.item.format === MruFileFormat.NoteBook || this.item.format === MruFileFormat.Form || this.item.format === MruFileFormat.MyAnalytics) {
            return this.item.lastModifiedTime;
        }

        return this.item.lastViewedTime;
    }

    private openUploadLocalModal(type: UploadActionType) {
        this.uploadLocalFileService.showModal(this.item.url, this.item.fileName, type);
    }

    private onAddToDoCallback(success: boolean = false, isPromoteTask: boolean = true, suggestedActionValue?: string) {
        if (!isPromoteTask) {
            return;
        }

        if (this.capabilitiesService.capabilities.contentActionsEnabled) {
            if (success) {
                this.contentActionsService.createToDoSuccessNotification(() => {
                    this.onViewToDoClick(suggestedActionValue);
                });
            } else {
                this.contentActionsService.createToDoErrorNotification();
            }
        }

        this.maybeAddViewTodo(success);
    }

    private maybeAddViewTodo(success: boolean) {
        if (!success) {
            return;
        }

        this.myAnalyticsState = MruMyAItemStates.Added;

        // Add View in To Do
        if (this.actionContextMenuEnabled) {
            this.addToContextMenuReact(this.createViewInToDoActionItemReact());
            this.removeFromContextMenuReact(this.addToToDoText);
        } else {
            this.addToContextMenu(this.createViewInToDoActionItem());
            this.removeFromContextMenu(this.addToToDoText);
        }
        if (this.showAsSuggestedAction) {
            this.setViewInToDoAsPrimaryAction();
        }
    }

    // Any @Input() item-specific component properties should be set here so they can properly be reflected on MRU update broadcasts.
    private async initializeItemFeatures() {
        if (this.isMicrosoftForms) {
            this.initializeFormsFeature();
        }
        const mruConfig = this.mruConfigService.config;
        this.showSharing = this.showSharing && !(this.mruAppType === FileType.OneNote && (MruFileFormat.Shared === this.item.format || MruFileFormat.ClassNoteBook === this.item.format || MruFileFormat.NoteBook === this.item.format))
            && !(this.isMicrosoftForms && this.item.format === MruFileFormat.Shared);
        this.isRecommended = this.item.format === MruFileFormat.Recommended;
        this.isOfficeFeed = this.item.format === MruFileFormat.News || this.item.format === MruFileFormat.OfficeFeedDocument || this.item.format === MruFileFormat.StreamsVideo || this.item.format === MruFileFormat.UpcomingMeeting || this.item.format === MruFileFormat.MyAnalytics;
        this.isNewsArticle = this.item.format === MruFileFormat.News;
        this.isUpcomingMeeting = this.item.format === MruFileFormat.UpcomingMeeting;
        this.isMyAnalytics = this.item.format === MruFileFormat.MyAnalytics;

        this.instrumentationArea = this.showAsSuggestedAction() ? KnownAreas.SuggestedActions : (this.isRecommended || this.isOfficeFeed ? KnownAreas.Recommended : KnownAreas.Documents);

        // In consumer, use the webUrl to help prevent redirects
        this.url = mruConfig.webUrlMruConsumerEnabled && this.isConsumer && this.item.webUrl ?
            this.item.webUrl :
            this.item.url;

        // TODO: Figure out a smarter truncation format
        const isPathArrayFileType = this.item.fileType !== FileType.Sway && this.item.fileType !== FileType.Project && this.item.fileType !== FileType.ProjectOperations;
        const hasSubject = this.item.isEmailAttachment && this.item.emailReference && this.item.emailReference.Subject;
        const pathsArray = PathArrayFormatter.Format(hasSubject ?
            [this.item.emailReference.Subject] :
            this.item.isEmailAttachment ? [this.locService.OpenFileLocationActionTitle] :
                // Using string "open file location" if we don't get a subject for email attachment
                // TODO: revert this once officefeed starts sending the actual email subject
                this.item.pathArray, this.contextService.isRtl, MruItemComponent.shortPathCharacterLimit);
        this.shortPath = isPathArrayFileType ? pathsArray[1] : null;
        this.plainTextPath = isPathArrayFileType ? pathsArray[0] : null;

        // TODO: revert this change as well after officefeed starts sending subject
        this.openFolderAriaLabel = this.item.isEmailAttachment ? this.locService.OpenFileLocationActionTitle : this.locService.format(this.locService.OpenFileLocationActionWithLocationTitle, this.plainTextPath);

        this.displayTime = this.getDisplayTime();
        this.displayTimeString = this.displayTime ? this.locService.localizedDateString(this.displayTime) : null;

        // SharedWithMe doesn't give back siteurl for email attachments, and the one we construct is not always correct,
        // and we do not fetch this in our shares calls, so disabling share control for email attachments for now
        this.shareControlEnabled = mruConfig.shareControlEnabled && this.item.fileType !== FileType.PowerBI && this.item.fileType !== FileType.Project && this.item.fileType !== FileType.ProjectOperations && this.item.fileType !== FileType.Portfolio && this.item.fileType !== FileType.Sway && this.item.fileType !== FileType.Forms && this.item.fileType !== FileType.StreamsVideo &&
            !(this.item.format === MruFileFormat.Shared && this.item.isEmailAttachment) && this.item.format !== MruFileFormat.UpcomingMeeting && this.item.fileType !== FileType.MyAnalytics;
        this.copyLinkEnabled = mruConfig.copyLinkEnabled && this.shareControlEnabled;
        this.mruPinEnabled = mruConfig.mruPinEnabled && this.item.format === MruFileFormat.Recent;
        // TODO: Consider opening the actual folder in Explorer
        this.clickableFolderEnabled = mruConfig.clickableFolderEnabled && !!this.item.attributionUrl;
        if (this.actionContextMenuEnabled) {
            await this.setupActionsMenuReact();
        } else {
            this.setupActionsMenu();
        }
        this.updateAnimation(this.item);
        this.setDescriptiveAriaLabel();
        this.thumbnailLoaded = this.thumbnailUrl && this.thumbnailUrl === this.getThumbnailUrl();
        this.dataSecurityThreshold = this.item.isLocal ? DataSecurityLevel.Enhanced : DataSecurityLevel.Security;
        this.activityDeepLink = this.recommendedDeepLinkEnabled && this.item.navigationId ? this.addLoginHint(`${this.url}&nav=${this.item.navigationId}`) : undefined;
        this.teamsDeepLink = this.recommendedTeamsLinkEnabled && this.item.teamsDeepLink;

        const fetchThumbnails = this.view === ItemView.Card || this.view === ItemView.Tile;
        this.inflationPromise = this.mruItemInflationService.inflateItem(this.item, fetchThumbnails, this.showAnalytics, this.mruAppType);
        this.inflationPromise.then(inflatedItem => {
            this.updateAnimation(inflatedItem);
            this.thumbnailUrl = this.getThumbnailUrl();
            this.thumbnailLoaded = !!this.thumbnailUrl;
            this.setBorderlessCardDetail1();
            this.setDescriptiveAriaLabel();
            if (this.capabilitiesService.wacHostEnabledForFileType(this.item.fileType) && this.item.wopiData && this.item.wopiData.wac && this.item.wopiData.wac.bootstrapperUrl) {
                this.uiHostBootstrapperService.loadBootstrapper(this.item.wopiData.wac.bootstrapperUrl, this.item.wopiData.wac.applicationUrl, this.item.fileType, true).then(() => {
                    if (this.officeRouteService.getCurrentRoute()?.route === OfficeRoute.Start) {
                        // Only attempt prebooting on start pages
                        this.wacContentService.prebootApplication(this.item.fileType, this.contextService.getWdOrigin(WdOriginType.Preboot));
                    }
                });
            }

            this.updateActionItemsOnInflated();
        });
    }

    private initializeFormsFeature() {
        this.isFormResponsesEnabled = this.mruAppType === FileType.Forms;
        this.formEnumType = this.item.getFormEnumType();
        this.categoryIcon = {};
        if (this.formEnumType === FormEnum.Poll) {
            this.categoryIcon.categoryFontIcon = IconFontType.PollResults;
            this.categoryIcon.categoryTooltip = this.locService.FormsPoll;
        } else if (this.formEnumType === FormEnum.Assignments) {
            this.categoryIcon.categoryFontIcon = IconFontType.AccountActivity;
            this.categoryIcon.categoryTooltip = this.locService.FormsAssignment;
        }
    }

    private updateActionItemsOnInflated() {
        const modifyItems = this.mruItemService.updateActionItemsOnInflated(
            this.index,
            this.item,
            this.isConsumer
        );

        if (this.actionContextMenuEnabled) {
            modifyItems.forEach(item => {
                this.actionContextMenu.actions = this.actionContextMenu.actions.filter(documentAction => documentAction.id !== item.item.id);
                const newActionContextMenuActions = [...this.actionContextMenu.actions];
                newActionContextMenuActions.splice(item.start, item.deleteCount, this.wrapAdditionalActionReact(item.item));
                this.actionContextMenu.actions = newActionContextMenuActions;
            });

        } else {
            modifyItems.forEach(item => {
                this.contextMenu.items = this.contextMenu.items.filter(actionItem => actionItem.getId() !== item.item.id);
                this.contextMenu.items.splice(item.start, item.deleteCount, this.wrapAdditionalAction(item.item));
            });
        }
    }

    private setBorderlessCardDetail1() {
        if (this.isMicrosoftForms) {
            this.borderlessCardDetail1 = this.item.metaData && this.item.metaData.formsResponseCount !== undefined && this.item.metaData.formsResponseCount !== null ? this.locService.format(this.locService.ResponsesText, this.item.metaData.formsResponseCount.toString()) : '';
        }
    }

    private setDescriptiveAriaLabel() {
        const descriptiveParts = [this.locService.format(this.locService.DocumentDescriptiveAriaLabelTitle, this.item.title)];
        if (this.showSharing && this.item.sharing) {
            descriptiveParts.push(this.locService.format(this.item.sharing.shared ? this.locService.DocumentDescriptiveAriaLabelShared : this.locService.DocumentDescriptiveAriaLabelPrivate, this.item.fileTypeName));
        }

        const descriptiveDate = this.buildDescriptiveDate();
        if (descriptiveDate) {
            descriptiveParts.push(descriptiveDate);
        }

        if (this.showActivity && !(this.isRecommended || this.isOfficeFeed)) {
            const activity = this.activityDescriptionService.activityDescription(this.item.activities, this.item.lastViewedTime, false);
            descriptiveParts.push((activity && activity.plainText) ? this.locService.format(this.locService.DocumentDescriptiveAriaLabelActivity, activity.plainText) : this.locService.DocumentDescriptiveAriaLabelNoActivity);
        }

        if (this.showAnalytics && this.analyticsDescriptiveAriaLabel) {
            descriptiveParts.push(this.analyticsDescriptiveAriaLabel);
        }

        if (this.isCardCreateByLabel) {
            if (this.item.createdBy) {
                descriptiveParts.push(this.locService.format(this.locService.DocumentDescriptiveAriaLabelCreatedBy, this.item.createdBy));
            }

            if (this.item.metaData && this.item.metaData.formsResponseCount !== undefined && this.item.metaData.formsResponseCount !== null) {
                descriptiveParts.push(this.locService.format(this.locService.DocumentDescriptiveAriaLabelNumResponses, this.item.metaData.formsResponseCount.toString()));
            }
        }

        this.descriptiveAriaLabel = descriptiveParts.join(' ');
    }

    private buildDescriptiveDate(): string {
        const dateString = this.responsiveRelativeDatePipe.transform(this.displayTime, false, this.displayTimeString, false);
        let descriptiveDate = dateString;
        if (dateString) {
            switch (this.item.format) {
                case MruFileFormat.Trending:
                    descriptiveDate = this.locService.format(this.locService.DocumentDescriptiveAriaLabelLastModified, dateString);
                    break;
                case MruFileFormat.Shared:
                    descriptiveDate = this.locService.format(this.locService.DocumentDescriptiveAriaLabelDateShared, dateString);
                    break;
                case MruFileFormat.Recommended:
                case MruFileFormat.News:
                case MruFileFormat.OfficeFeedDocument:
                    descriptiveDate = this.item.activity && this.item.activity.plainText ? this.item.activity.plainText + dateString : '';
                    break;
                default:
                    descriptiveDate = this.locService.format(this.locService.DocumentDescriptiveAriaLabelLastOpened, dateString);
            }
        }
        return descriptiveDate;
    }

    private focusOnShareAction() {
        if (this.currentShareSource === 'topLevel') {
            this.shareTopLevelElement.nativeElement.focus();
        } else {
            this.actionsMenuElement.dropdownMenu.dropdownLink.nativeElement.focus();
        }
    }

    private removeShareControlListeners() {
        if (this.shareControlClickListener) {
            this.shareControlClickListener();
        }

        if (this.shareControlTouchListener) {
            this.shareControlTouchListener();
        }

        if (this.shareControlKeyListener) {
            this.shareControlKeyListener();
        }
    }

    private updateAnimation(mruItem: MruFileItem) {
        this.isNew = mruItem.isNew;
        this.isNewAnimationState = this.isNew ? 'active' : 'inactive';
    }

    private updatePinnedState(isPinned: boolean, event: Event, source: 'topLevel' | 'menu') {
        if (event) {
            event.preventDefault();
        }

        this.item.lastViewedTime = this.dateService.getCurrentDate();
        this.displayTime = this.getDisplayTime();
        this.displayTimeString = this.displayTime ? this.locService.localizedDateString(this.displayTime) : null;

        this.changePinState.emit({ item: this.item, isPinned, element: this.mruListItem, index: this.index });

        if (this.actionContextMenuEnabled) {
            if (!('id' in this.pinAction) || !('id' in this.unpinAction)) {
                return;
            }
            const index = this.actionContextMenu.actions.findIndex(_ => _.id === (isPinned ? this.pinActionId : this.unpinActionId));
            if (index === -1) {
                return;
            }
            this.actionContextMenu.actions = this.actionContextMenu.actions.slice(0, index).concat(
                isPinned ? this.unpinAction : this.pinAction,
                this.actionContextMenu.actions.slice(index + 1, this.actionContextMenu.actions.length));
        } else {
            if (!('getId' in this.pinAction) || !('getId' in this.unpinAction)) {
                return;
            }
            const index = this.contextMenu.items.findIndex(_ => _.getId() === (isPinned ? this.pinActionId : this.unpinActionId));
            if (index === -1) {
                return;
            }
            this.contextMenu.items[index] = isPinned ? this.unpinAction : this.pinAction;
            this.instrumentAction(`${isPinned ? 'pin' : 'unpin'}_${source}`);
        }

        this.itemFocused = false;
    }

    private async setupActionsMenuReact() {
        const mruConfig = this.mruConfigService.config;
        this.item.downloadUrl = this.item.documentUrl;
        const sourceUXComponent: KnownAreaInst = this.showAsSuggestedAction() ? 'SuggestedActions' : (this.isRecommended || this.isOfficeFeed ? 'Recommended' : 'Documents');
        const itemElementId = `${this.listId}-${this.item.id}`;
        let actions: ReadonlyArray<DocumentAction> = await this.contentActionsService.createDocumentActions(this.item, itemElementId, sourceUXComponent, this.listId);
        const groupInfo = await this.contentActionsService.getContentActionsGroupInfo();

        if (this.item.isLocal) {
            actions = actions.concat(this.createUploadActionItemReact());
        }

        if (this.item.format === MruFileFormat.Recent && this.mruPinEnabled) {
            let pinUnpinAction: DocumentAction;
            this.createPinUnpinActionItemsReact();

            if (this.item.isPinned) {
                pinUnpinAction = this.unpinAction as DocumentAction;
            } else {
                pinUnpinAction = this.pinAction as DocumentAction;
            }
            actions = actions.concat(pinUnpinAction);
        }

        // PWA TODO: Handle file removal for local files
        if (!this.item.isLocal && (this.item.format === MruFileFormat.Recent || ((this.isRecommended || (this.isOfficeFeed && !this.isMyAnalytics)) && mruConfig.recommendedRemoveItemEnabled))) {
            const removeAction = this.createRemoveActionItemReact();
            actions = actions.concat(removeAction);
        }

        if (this.item.format === MruFileFormat.ClassNoteBook) {
            actions = actions.concat(this.createCopyClassNoteBookActionItemReact());
        }

        const additionalItems = this.mruItemService.generateAdditionalActionsMenuItems(this.index, this.item, this.isConsumer);
        additionalItems.forEach(item => { actions = actions.concat(this.wrapAdditionalActionReact(item)); });

        if (this.item.fileType === FileType.MyAnalytics) {
            // Potential actions
            this.item.potentialAction.forEach(action => {
                const actionName: PotentialActionType = action.name;
                const actionText = this.getTextByActionType(actionName);
                actions = actions.concat({
                    id: actionName,
                    title: actionText,
                    ariaLabel: actionText,
                    contentActionOptions: {
                        icon: this.getIconReactByActionType(actionName)
                    },
                    executeAction: () => {
                        this.executeFeedAction(actionName, this.item.feedbackId, actionName, action.actionPayload);
                        if (actionName === PotentialActionType.DismissAction || actionName === PotentialActionType.MarkAsNotATask || actionName === PotentialActionType.MarkTaskAsDone) {
                            this.removeItem();
                        }
                    },
                    disabled: false
                });
            });
        }

        // Construct the context menu
        this.actionContextMenu = {
            id: this.getContextMenuId(),
            itemIndex: this.index,
            actions,
            groupInfo,
            mouseEvent: undefined,
            targetElement: undefined
        };

        this.showActionsMenu = actions.length > 0;
        // Initialize old context menu with bare minimum to create the '...' button.
        this.contextMenu = {
            id: this.getContextMenuId(),
            items: []
        };

        // Primary action setup
        if (this.showAsSuggestedAction() && this.item.activity && this.item.activity.reasonType) {
            this.setupPrimaryAction();
        }
    }

    private setupActionsMenu() {
        const mruConfig = this.mruConfigService.config;
        const applicationSpecificIconData = MruItemComponent.applicationConversionMap.get(this.item.fileType);
        const appIconsEnabled = mruConfig.newMruActions && applicationSpecificIconData;
        let actionsMenuItems: Array<ContextMenuItem>;

        if (this.item.isEmailAttachment) {
            const openAttachmentTitle = this.item.format === MruFileFormat.OfficeFeedDocument || this.item.emailReference.AttachmentType === AttachmentType.Classic
                ? this.locService.OpenInOutlookActionTitle
                : this.locService.format(this.locService.OpenOnlineActionTitle, this.item.application);
            actionsMenuItems = [{
                getId: () => 'open',
                title: openAttachmentTitle,
                ariaLabel: openAttachmentTitle,
                iconCssClass: appIconsEnabled ? applicationSpecificIconData.iconFontClass : '',
                icon: appIconsEnabled ? null : IconFontType.FolderOpen,
                iconColor: appIconsEnabled ? applicationSpecificIconData.iconFontColor : null,
                executeAction: () => {
                    if (this.capabilitiesService.capabilities.contentLauncherEnabled) {
                        import('@office-start/launcher-service').then(
                            launchSvc => {
                                launchSvc.launchUrl(this.url, { action: 'OpenAttachment' });
                            }
                        );
                    } else {
                        this.urlLauncherService.openUrl(this.url, LaunchAction.OpenAttachment);
                    }
                    this.instrumentAction('open');
                }
            }];

            if (this.shareControlEnabled && this.item.emailReference?.AttachmentType !== AttachmentType.Classic) {
                this.getShareControlElements(actionsMenuItems);
            }

            if ((this.isRecommended || (this.isOfficeFeed && !this.isMyAnalytics)) && mruConfig.recommendedRemoveItemEnabled) {
                actionsMenuItems.push(this.createRemoveActionItem());
            }

            this.showActionsMenu = true;
            this.contextMenu = {
                id: this.getContextMenuId(),
                items: actionsMenuItems,
                customLogging: true,
                cssClass: MruItemComponent.actionsMenuCssClass
            };

            // TODO: not sure this will ever be relevant
            this.primaryAction = actionsMenuItems[0];
            this.primaryActionIconFont = IconFontType.FolderOpen;
            return;
        }

        actionsMenuItems = [];

        if (!this.disableFileNavigation && this.item.fileType !== FileType.MyAnalytics) {
            actionsMenuItems.push({
                getId: () => 'open',
                title: this.isUpcomingMeeting ? this.locService.OpenInCalendar : this.locService.OpenInBrowser,
                ariaLabel: this.isUpcomingMeeting ? this.locService.OpenInCalendar : this.locService.OpenInBrowser,
                iconCssClass: appIconsEnabled ? applicationSpecificIconData.iconFontClass : '',
                icon: appIconsEnabled ? null : this.isUpcomingMeeting ? IconFontType.Calendar : IconFontType.FolderOpen,
                iconColor: appIconsEnabled ? applicationSpecificIconData.iconFontColor : null,
                executeAction: this.item.isLocal ?
                    () => this.openUploadLocalModal(UploadActionType.Open)
                    : () => {
                        // Using webUrl here to avoid launching the mobile app even if it's installed.
                        // Some apps don't have webUrl, so fallback to url.
                        const [launchUrl] = this.getLaunchUrlAndClickId(this.item.webUrl ?? this.url, true);
                        if (this.capabilitiesService.capabilities.contentLauncherEnabled) {
                            import('@office-start/launcher-service').then(
                                launchSvc => {
                                    launchSvc.launchUrl(launchUrl, { action: 'OpenFile' });
                                }
                            );
                        } else {
                            this.urlLauncherService.openUrl(launchUrl, LaunchAction.OpenFile);
                        }
                        this.instrumentAction('open');
                    },
                disabled: this.item.isLocal
            });
        }

        if (this.item.isLocal) {
            actionsMenuItems.push(this.createUploadActionItem());
        }

        if (this.shareControlEnabled) {
            this.showDesktopShareControl = false;
            this.getShareControlElements(actionsMenuItems);
        }

        const openFileLocationAndDownloadAvailable = this.item.fileType !== FileType.PowerBI && this.item.fileType !== FileType.Sway && this.item.fileType !== FileType.OneNote && this.item.fileType !== FileType.Forms && this.item.fileType !== FileType.Project && this.item.fileType !== FileType.ProjectOperations && this.item.fileType !== FileType.Portfolio && this.item.fileType !== FileType.StreamsVideo && this.item.format !== MruFileFormat.UpcomingMeeting && this.item.format !== MruFileFormat.MyAnalytics;
        if (mruConfig.newMruActions) {
            if (applicationSpecificIconData && applicationSpecificIconData.nativeUriScheme) {
                const openInApp = this.deviceDetector.isDesktopDevice() ? this.locService.OpenInDesktopApp : this.deviceDetector.isMobileDevice() || this.deviceDetector.isTabletDevice() ? this.locService.OpenInApp : this.locService.OpenActionTitle;
                const openInAppAction: ContextMenuItem = {
                    getId: () => 'openInApp',
                    title: openInApp,
                    ariaLabel: openInApp,
                    iconCssClass: appIconsEnabled ? applicationSpecificIconData.iconFontClass : '',
                    icon: appIconsEnabled ? null : IconFontType.FolderOpen,
                    iconColor: appIconsEnabled ? applicationSpecificIconData.iconFontColor : null,
                    executeAction: () => {
                        this.localAppLauncherService.launchOfficeApp(this.item.application, this.item.canonicalUrl).then(success => {
                            if (success) {
                                return;
                            }
                            if (this.item.isLocal) {
                                const url = `${applicationSpecificIconData.nativeUriScheme}${this.item.canonicalUrl}`;
                                if (this.capabilitiesService.capabilities.contentLauncherEnabled) {
                                    import('@office-start/launcher-service').then(
                                        launchSvc => {
                                            launchSvc.launchUrl(url, { action: 'OpenInApp', linkTarget: '_self' }).catch(() => {
                                                // PWA TODO: Do we really want to prompt for upload when we fail to open the file?
                                                this.openUploadLocalModal(UploadActionType.Open);
                                            });
                                        }
                                    );
                                } else {
                                    this.urlLauncherService.openUrl(url, LaunchAction.OpenInApp, LinkTarget.SameFrame).catch(() => {
                                        // PWA TODO: Do we really want to prompt for upload when we fail to open the file?
                                        this.openUploadLocalModal(UploadActionType.Open);
                                    });
                                }
                            } else {
                                throw new Error('fallback to protocol handler');
                            }
                        }).catch(() => {
                            const queryIndex = this.item.canonicalUrl.lastIndexOf('?');
                            let canonicalUrl = this.item.canonicalUrl;
                            if (queryIndex > 0) {
                                // Strip any query params off the canonical url, as it is not needed for launching desktop apps
                                canonicalUrl = canonicalUrl.substring(0, queryIndex);
                            }
                            const url = `${applicationSpecificIconData.nativeUriScheme}${canonicalUrl}`;
                            if (this.capabilitiesService.capabilities.contentLauncherEnabled) {
                                import('@office-start/launcher-service').then(
                                    launchSvc => {
                                        launchSvc.launchUrl(url, { action: 'OpenInApp', linkTarget: '_self' });
                                    }
                                );
                            } else {
                                this.urlLauncherService.openUrl(url, LaunchAction.OpenInApp, LinkTarget.SameFrame);
                            }
                        });
                        this.instrumentAction('openInApp');
                    }
                };
                actionsMenuItems.splice(1, 0, openInAppAction);
            }

            // Enable download action only for items from ODSP (driveId and url check) that users have permissions to
            // Excluding Stream videos because download is blocked by default, and opening the canonical URLs would just load inline video player for most modern browsers.
                // TODO: We can remove this check once ODSP download url shows a more useful error page if users don't have permissions to download Stream videos
            if (this.downloadActionEnabled && openFileLocationAndDownloadAvailable && mruConfig.showDownloadAction && !this.item.isLocal && this.item.format !== MruFileFormat.News && this.item.fileType !== FileType.Fluid && !isVideoFiletype(this.item.fileType) && this.item.driveId && this.item.documentUrl) {
                actionsMenuItems.push({
                    getId: () => 'download',
                    title: this.locService.DownloadMruItemActionTitle,
                    ariaLabel: this.locService.DownloadMruItemActionTitle,
                    icon: IconFontType.Download,
                    executeAction: () => {
                        const downloadUrlPromise = this.oneDriveService.getDownloadUrl({
                            driveId: this.item.driveId,
                            itemId: this.item.docId,
                            itemUrl: this.item.documentUrl
                        }).then(downloadUrl => {
                            if (!downloadUrl) {
                                throw new Error('Empty download url');
                            }
                            return downloadUrl;
                        }).catch(error => {
                            this.instrumentationService.logGenericEvent(KnownInstrumentationEvents.GetDownloadUrlError, {
                                [InstrumentationParam.Error]: error?.toString() || '',
                                [InstrumentationParam.Area]: this.instrumentationArea
                            });
                            logError({ eventName: KnownErrorInstrumentationEvents.GetDownloadUrlError, message: error?.toString() || '', debugInfo: this.instrumentationArea });
                            return this.item.documentUrl;
                        });

                        downloadUrlPromise.then(downloadUrl => {
                            // PWA TODO : Figure out if there is better way to download than opening link in browser
                            if (this.capabilitiesService.capabilities.contentLauncherEnabled) {
                                import('@office-start/launcher-service').then(
                                    launchSvc => {
                                        launchSvc.launchUrl(downloadUrl, {action: 'Download'});
                                    }
                                );
                            } else {
                                this.urlLauncherService.openUrl(downloadUrl, LaunchAction.Download);
                            }
                            this.instrumentAction('download');
                        });
                    }
                });
            }

            if (openFileLocationAndDownloadAvailable) {
                actionsMenuItems.push({
                    getId: () => 'openFileLocation',
                    title: this.locService.OpenFileLocationActionTitle,
                    ariaLabel: this.openFolderAriaLabel,
                    icon: IconFontType.Folder,
                    executeAction: () => {
                        this.openFolder();
                        this.instrumentAction('openFileLocation');
                    }
                });
            }
        }

        if (this.item.format === MruFileFormat.Recent && this.mruPinEnabled) {
            let pinUnpinAction: ContextMenuItem;
            this.createPinUnpinActionItems();

            if (this.item.isPinned) {
                pinUnpinAction = this.unpinAction as ContextMenuItem;
            } else {
                pinUnpinAction = this.pinAction as ContextMenuItem;
            }

            if (mruConfig.newMruActions && openFileLocationAndDownloadAvailable) {
                actionsMenuItems.splice(actionsMenuItems.length - (this.item.isLocal ? 1 : 2), 0, pinUnpinAction);
            } else {
                actionsMenuItems.push(pinUnpinAction);
            }
        }

        // PWA TODO: Handle file removal for local files
        if (!this.item.isLocal && (this.item.format === MruFileFormat.Recent || ((this.isRecommended || (this.isOfficeFeed && !this.isMyAnalytics)) && mruConfig.recommendedRemoveItemEnabled))) {
            const removeAction = this.createRemoveActionItem();

            if (mruConfig.newMruActions && openFileLocationAndDownloadAvailable) {
                actionsMenuItems.splice(actionsMenuItems.length - 1, 0, removeAction);
            } else {
                actionsMenuItems.push(removeAction);
            }
        }

        if (this.item.format === MruFileFormat.ClassNoteBook) {
            actionsMenuItems.push(this.createCopyClassNoteBookActionItem());
        }

        const additionalItems = this.mruItemService.generateAdditionalActionsMenuItems(this.index, this.item, this.isConsumer);

        additionalItems.forEach(item => actionsMenuItems.push(this.wrapAdditionalAction(item)));

        if (this.item.fileType === FileType.MyAnalytics) {

            // open in Email
            actionsMenuItems.push({
                getId: () => 'open',
                title: this.locService.OpenInOutlookActionTitle,
                ariaLabel: this.locService.OpenInOutlookActionTitle,
                icon: IconFontType.Outlook,
                executeAction: () => {
                    const [launchUrl] = this.getLaunchUrlAndClickId(this.item.webUrl ?? this.url, true);
                    if (this.capabilitiesService.capabilities.contentLauncherEnabled) {
                        import('@office-start/launcher-service').then(
                            launchSvc => {
                                launchSvc.launchUrl(launchUrl, { action: 'OpenFile' });
                            }
                        );
                    } else {
                        this.urlLauncherService.openUrl(launchUrl, LaunchAction.OpenFile);
                    }

                    this.instrumentAction('open');
                },
                disabled: false
            });

            // potential actions
            this.item.potentialAction.forEach(action => {
                const actionText = this.getTextByActionType(action.name);
                const actionName: PotentialActionType = action.name;
                actionsMenuItems.push({
                    getId: () => actionName,
                    title: actionText,
                    ariaLabel: actionText,
                    icon: this.getIconByActionType(action.name),
                    executeAction: () => {
                        this.executeFeedAction(actionName, this.item.feedbackId, actionName, action.actionPayload);
                        if (actionName === PotentialActionType.DismissAction || actionName === PotentialActionType.MarkAsNotATask || actionName === PotentialActionType.MarkTaskAsDone) {
                            this.removeItem();
                        }
                        this.instrumentAction(actionName);
                    },
                    disabled: false
                });
            });
        }

        this.showActionsMenu = !(actionsMenuItems.length === 1 && actionsMenuItems[0].getId() === 'open');
        this.contextMenu = {
            id: this.getContextMenuId(),
            items: actionsMenuItems,
            customLogging: true,
            cssClass: (this.leftNavEnabled ? 'actions-menu--left-nav ' : '') + MruItemComponent.actionsMenuCssClass + (this.isTouch && (this.isRecommended || this.isOfficeFeed) ? ' actions-menu--mobile' : '')
        };

        if (this.showAsSuggestedAction() && this.item.activity && this.item.activity.reasonType) {
            this.setupPrimaryAction();
        }
    }

    private setupPrimaryAction(): void {
        switch (this.item.activity.reasonType) {
            case ActivityReason.MyAnalytics:
                this.primaryAction = {
                    title: this.addToToDoText,
                    ariaLabel: this.addToToDoText,
                    getId: () => 'suggestedActionsAddToToDo',
                    executeAction: () => {
                        this.executeFeedAction('add_todo', this.item.feedbackId, PotentialActionType.PromoteTask, this.getActionPayLoadByName(PotentialActionType.PromoteTask), 'add_todo');
                    }
                };
                this.primaryActionIconFont = IconFontType.ToDo;
                break;
            case ActivityReason.Task:
                this.primaryAction = {
                    title: this.suggestedActionsViewTaskTitle,
                    ariaLabel: this.suggestedActionsViewTaskTitle,
                    getId: () => 'suggestedActionsViewTask',
                    executeAction: async () => {
                        this.onSuggestedActionsClick(this.activityDeepLink, LaunchAction.OpenFile, 'open', 'view_task', true);
                    }
                };
                this.showListSvg = true;
                break;
            case ActivityReason.Comment:
            case ActivityReason.Mention:
                this.primaryAction = {
                    title: this.suggestedActionsReplyTitle,
                    ariaLabel: this.suggestedActionsReplyTitle,
                    getId: () => 'suggestedActionsReply',
                    executeAction: () => {
                        this.onSuggestedActionsClick(this.activityDeepLink, LaunchAction.OpenFile, 'open', 'reply', true);
                    }
                };
                this.showReplySvg = true;
                break;
            case ActivityReason.Edit:
            case ActivityReason.Trending:
                this.primaryAction = {
                    title: this.suggestedActionsViewChangesTitle,
                    ariaLabel: this.suggestedActionsViewChangesTitle,
                    getId: () => 'suggestedActionsViewChanges',
                    executeAction: () => {
                        this.onSuggestedActionsClick(this.activityDeepLink, LaunchAction.OpenFile, 'open', 'view_changes', true);
                    }
                };
                this.primaryActionIconFont = IconFontType.Pencil;
                break;
            case ActivityReason.Meeting:
                this.primaryAction = {
                    title: this.suggestedActionsMeetingTitle,
                    ariaLabel: this.suggestedActionsMeetingTitle,
                    getId: () => 'suggestedActionsMeeting',
                    executeAction: () => {
                        this.onSuggestedActionsClick(this.item.joinUrl, LaunchAction.OpenTeamsMeeting, 'join_meeting', 'upcoming_meeting');
                    }
                };
                this.showMeetingSvg = true;
                break;
            default:
                if (this.actionContextMenuEnabled) {
                    this.primaryAction = this.actionContextMenu.actions[0];
                } else {
                    this.primaryAction = this.contextMenu.items[0];
                }
                this.primaryActionIconFont = IconFontType.Compass;
        }
    }

    private getTextByActionType(actionType: PotentialActionType) {
        let actionText = '';
        switch (actionType) {
            case PotentialActionType.DismissAction:
                actionText = this.locService.RemoveDocumentActionTitle;
                break;
            case PotentialActionType.PromoteTask:
                actionText = this.addToToDoText;
                break;
            case PotentialActionType.MarkAsNotATask:
                actionText = this.notATaskText;
                break;
            case PotentialActionType.MarkTaskAsDone:
                actionText = this.doneText;
                break;
            default:
                actionText = '';
        }
        return actionText;
    }

    private getIconByActionType(actionType: PotentialActionType): IconFontType {
        let icon: IconFontType = IconFontType.ToDo;
        switch (actionType) {
            case PotentialActionType.DismissAction:
                icon = IconFontType.Minus;
                break;
            case PotentialActionType.PromoteTask:
                icon = IconFontType.ToDo;
                break;
            case PotentialActionType.MarkAsNotATask:
                icon = IconFontType.X;
                break;
            case PotentialActionType.MarkTaskAsDone:
                icon = IconFontType.CheckMark;
                break;
            default:
                icon = IconFontType.ToDo;
        }
        return icon;
    }

    private getIconReactByActionType(actionType: PotentialActionType): ContentActionIcon {
        switch (actionType) {
            case PotentialActionType.DismissAction:
                return {
                    type: ActionContextMenuItemIcon.ActionContextMenuIcon,
                    iconName: 'SubtractIcon'
                };
            case PotentialActionType.PromoteTask:
                return {
                    type: ActionContextMenuItemIcon.Svg,
                    iconName: 'ToDoSvgIcon'
                };
            case PotentialActionType.MarkAsNotATask:
                return {
                    type: ActionContextMenuItemIcon.ActionContextMenuIcon,
                    iconName: 'DismissIcon'
                };
            case PotentialActionType.MarkTaskAsDone:
                return {
                    type: ActionContextMenuItemIcon.ActionContextMenuIcon,
                    iconName: 'CheckmarkIcon'
                };
            default:
                return {
                    type: ActionContextMenuItemIcon.Svg,
                    iconName: 'ToDoSvgIcon'
                };
        }
    }

    private getIconReactByIconFontType(icon: IconFontType): ContentActionIcon {
        switch (icon) {
            case IconFontType.Copy:
                return {
                    type: ActionContextMenuItemIcon.ActionContextMenuIcon,
                    iconName: 'CopyIcon'
                };
            case IconFontType.Delete:
                return {
                    type: ActionContextMenuItemIcon.ActionContextMenuIcon,
                    iconName: 'DeleteIcon'
                };
            case IconFontType.Move:
                return {
                    type: ActionContextMenuItemIcon.ActionContextMenuIcon,
                    iconName: 'MoveFolderIcon'
                };
            case IconFontType.Restore:
                return {
                    type: ActionContextMenuItemIcon.ActionContextMenuIcon,
                    iconName: 'RestoreIcon'
                };
            case IconFontType.Unpin:
                return {
                    type: ActionContextMenuItemIcon.ActionContextMenuIcon,
                    iconName: 'UnpinIcon'
                };
            default:
                return {
                    type: ActionContextMenuItemIcon.ActionContextMenuIcon,
                    iconName: 'DocumentIcon'
                };
        }
    }

    private getShareControlElements(actionsMenuItems: Array<ContextMenuItem>) {
        actionsMenuItems.push({
            getId: () => 'share',
            title: this.shareActionTitle,
            ariaLabel: this.shareActionTitle,
            icon: IconFontType.Share2,
            executeAction: event => {
                this.onShareClick(event, 'menu', ShareControlMode.Share);
            },
            disabled: this.item.isLocal
        });
        if (this.copyLinkEnabled) {
            actionsMenuItems.push({
                getId: () => 'copylink',
                title: this.copyLinkActionTitle,
                ariaLabel: this.copyLinkActionTitle,
                icon: IconFontType.Link,
                executeAction: event => {
                    this.onShareClick(event, 'menu', ShareControlMode.CopyLink);
                },
                disabled: this.item.isLocal
            });
        }
        // This is to prefetch the share token, which is why we don't use the returned promise.
        // The share control will use the cached token when it is opened.
        // Share control is designed for cloud resources only.Do not try to prefetch token for onprem resources
        // as they will result in failure.For ANTP , do not prefetch at all.
        if (!this.item.isOnPremOrVanity) {
            this.shareControlService.getToken(this.item.documentUrl, false, this.item.fileType);
        }
    }

    private createCopyClassNoteBookActionItem(): ContextMenuItem {
        return {
            getId: () => 'copyClassNoteBook',
            title: this.locService.SaveAClassNotebook,
            ariaLabel: this.saveAClassNotebook,
            icon: IconFontType.Save,
            executeAction: () => {
                if (this.capabilitiesService.capabilities.contentLauncherEnabled) {
                    import('@office-start/launcher-service').then(
                        launchSvc => {
                            launchSvc.launchUrl(this.onenoteService.generateSaveCopyClassNotebookLink(this.item.docId, this.item.fileName, this.url), { action: 'CopyNotebook', linkTarget: '_NewSaveCopyWindow', width: 500, height: 500 });
                        }
                    );
                } else {
                    this.urlLauncherService.openUrl(this.onenoteService.generateSaveCopyClassNotebookLink(this.item.docId, this.item.fileName, this.url), LaunchAction.CopyNotebook, LinkTarget.NewSaveCopyWindow, 500, 500);
                }

                this.instrumentAction('copyClassNoteBook');
            }
        };
    }

    private createCopyClassNoteBookActionItemReact(): DocumentAction {
        return {
            id: 'copyClassNoteBook',
            title: this.locService.SaveAClassNotebook,
            ariaLabel: this.saveAClassNotebook,
            contentActionOptions: {
                icon: {
                    type: ActionContextMenuItemIcon.ActionContextMenuIcon,
                    iconName: 'SaveIcon'
                }
            },
            executeAction: () => {
                if (this.capabilitiesService.capabilities.contentLauncherEnabled) {
                    import('@office-start/launcher-service').then(
                        launchSvc => {
                            launchSvc.launchUrl(this.onenoteService.generateSaveCopyClassNotebookLink(this.item.docId, this.item.fileName, this.url), { action: 'CopyNotebook', linkTarget: '_NewSaveCopyWindow', width: 500, height: 500 });
                        }
                    );
                } else {
                    this.urlLauncherService.openUrl(this.onenoteService.generateSaveCopyClassNotebookLink(this.item.docId, this.item.fileName, this.url), LaunchAction.CopyNotebook, LinkTarget.NewSaveCopyWindow, 500, 500);
                }

                this.instrumentAction('copyClassNoteBook');
            },
            disabled: false
        };
    }

    private createPinUnpinActionItems(): void {
        this.pinAction = {
            getId: () => this.pinActionId,
            title: this.pinActionTitle,
            ariaLabel: this.pinActionTitle,
            icon: IconFontType[this.pinActionIcon],
            executeAction: () => this.pinItem(null, 'menu'),
            disabled: this.item.isLocal
        };

        this.unpinAction = {
            getId: () => this.unpinActionId,
            title: this.unpinActionTitle,
            ariaLabel: this.unpinActionTitle,
            icon: IconFontType[this.unpinActionIcon],
            executeAction: () => this.unpinItem(null, 'menu'),
            disabled: this.item.isLocal
        };
    }

    private createPinUnpinActionItemsReact(): void {
        this.pinAction = {
            id: this.pinActionId,
            title: this.pinActionTitle,
            ariaLabel: this.pinActionTitle,
            contentActionOptions: {
                icon: this.pinActionIconReact
            },
            executeAction: () => this.runUnregisteredAction(this.pinActionId, () => this.pinItem(null, 'menu')),
            disabled: this.item.isLocal
        };

        this.unpinAction = {
            id: this.unpinActionId,
            title: this.unpinActionTitle,
            ariaLabel: this.unpinActionTitle,
            contentActionOptions: {
                icon: this.unpinActionIconReact
            },
            executeAction: () => this.runUnregisteredAction(this.unpinActionId, () => this.unpinItem(null, 'menu')),
            disabled: this.item.isLocal
        };
    }

    private createRemoveActionItem(): ContextMenuItem {
        return {
            getId: () => 'remove',
            title: this.locService.RemoveDocumentActionTitle,
            ariaLabel: this.locService.RemoveDocumentActionTitle,
            icon: IconFontType.Minus,
            executeAction: () => this.removeItem()
        };
    }

    private createRemoveActionItemReact(): DocumentAction {
        return {
            id: 'remove',
            title: this.locService.RemoveDocumentActionTitle,
            ariaLabel: this.locService.RemoveDocumentActionTitle,
            contentActionOptions: {
                icon: {
                    type: ActionContextMenuItemIcon.ActionContextMenuIcon,
                    iconName: 'SubtractIcon'
                }
            },
            executeAction: () => this.removeItem(),
            disabled: false
        };
    }

    private createUploadActionItem(): ContextMenuItem {
        return {
            getId: () => 'upload',
            title: this.uploadAndOpen,
            ariaLabel: this.uploadAndOpen,
            icon: IconFontType.Upload,
            executeAction: () => {
                this.uploadLocal();
            }
        };
    }

    private createUploadActionItemReact(): DocumentAction {
        return {
            id: 'upload',
            title: this.uploadAndOpen,
            ariaLabel: this.uploadAndOpen,
            contentActionOptions: {
                icon: {
                    type: ActionContextMenuItemIcon.ActionContextMenuIcon,
                    iconName: 'UploadIcon'
                }
            },
            executeAction: () => this.runUnregisteredAction('upload', this.uploadLocal),
            disabled: false
        };
    }

    private createViewInToDoActionItem(suggestedActionValue?: string): ContextMenuItem {
        return {
            getId: () => 'todo',
            title: this.viewInToDoText,
            ariaLabel: this.viewInToDoText,
            icon: IconFontType.ToDo,
            executeAction: () => {
                this.onViewToDoClick(suggestedActionValue);
            },
            disabled: false
        };
    }

    private createViewInToDoActionItemReact(suggestedActionValue?: string): DocumentAction {
        return {
            id: 'todo',
            title: this.viewInToDoText,
            ariaLabel: this.viewInToDoText,
            contentActionOptions: {
                icon: {
                    type: ActionContextMenuItemIcon.Svg,
                    iconName: 'ToDoSvgIcon'
                }
            },
            executeAction: () => this.runUnregisteredAction('todo', () => this.onViewToDoClick(suggestedActionValue)),
            disabled: false
        };
    }

    private setViewInToDoAsPrimaryAction(): void {
        this.primaryAction = this.createViewInToDoActionItem('view_todo');
        this.primaryActionIconFont = IconFontType.ToDo;
    }

    private getContextMenuId(): string {
        return `${this.listId}-${this.item.id}`;
    }

    private executeFeedAction(
        actionId: string,
        feedbackIds: string,
        actionType: PotentialActionType,
        payload: string,
        suggestedActionValue?: string): void {
        const isPromoteTask = actionType === PotentialActionType.PromoteTask;
        if (this.actionContextMenuEnabled) {
            this.runUnregisteredAction(
                actionId,
                () => {
                    this.officeFeedService.performAction(feedbackIds, actionType, payload)
                        .then(success => {
                            this.onAddToDoCallback(success, isPromoteTask, suggestedActionValue);
                        }).catch(_reason => {
                            this.onAddToDoCallback(false, isPromoteTask, suggestedActionValue);
                        });
                }
            );
        } else {
            this.officeFeedService.performAction(feedbackIds, actionType, payload)
                .then(success => {
                    this.onAddToDoCallback(success, isPromoteTask, suggestedActionValue);
                })
                .catch(_reason => {
                    this.onAddToDoCallback(false, isPromoteTask, suggestedActionValue);
                });
        }
    }

    private async runUnregisteredAction(id: string, action: () => void) {
        const { referral, referralPlatform } = this.maybeGetReferralAndPlatform(id);
        this.contentActionsService.runUnregisteredAction(id, action, this.instrumentationArea, this.getInstrumentationParams(), referral, referralPlatform);
    }

    private getClickData(event: Event): InstrumentationData {
        const eventName = this.showAsSuggestedAction() ? KnownInstrumentationEvents.SuggestedActionClick : (this.isRecommended || this.isOfficeFeed ? KnownInstrumentationEvents.RecommendedClick : KnownInstrumentationEvents.MruClick);
        const clickData = this.item.getClickData(eventName, KnownInstrumentationActions.Click, this.index);
        const clickTarget = event.target;
        if (this.titleElement && clickTarget === this.titleElement.nativeElement) {
            clickData.params[InstrumentationParam.ItemId] = 'title';
        } else if (this.fileIconElement && clickTarget === this.fileIconElement.nativeElement) {
            clickData.params[InstrumentationParam.ItemId] = 'icon';
        } else if (this.attributionElement && clickTarget === this.attributionElement.nativeElement) {
            clickData.params[InstrumentationParam.ItemId] = 'attribution';
        } else if (this.timestampElement && clickTarget === this.timestampElement.nativeElement) {
            clickData.params[InstrumentationParam.ItemId] = 'timestamp';
        } else if (this.myAnalyticsTaskDoneElement && clickTarget === this.myAnalyticsTaskDoneElement.nativeElement) {
            clickData.params[InstrumentationParam.ItemId] = 'taskDoneLink';
        } else if (this.myAnalyticsAddToDoElement && clickTarget === this.myAnalyticsAddToDoElement.nativeElement) {
            clickData.params[InstrumentationParam.ItemId] = 'addToDoLink';
        } else {
            clickData.params[InstrumentationParam.ItemId] = 'item';
        }

        if (typeof this.relativeIndex !== 'undefined') {
            clickData.params[InstrumentationParam.RelativeIndex] = this.relativeIndex.toString();
        }

        clickData.params[InstrumentationParam.ItemCategory] = this.listId;
        clickData.params[InstrumentationParam.State] = this.view;
        clickData.params[InstrumentationParam.ResourceId] = this.item.resourceId;

        if (this.activityEnabled) {
            const allActivities = this.item.activities || [];
            const filteredActivities = this.activityDescriptionService.filterActivities(allActivities, this.item.lastViewedTime) || [];
            clickData.params[InstrumentationParam.ActivityCommentsCount] = filteredActivities.filter(activity => activity.action.type === ActionType.Comment).length.toString();
            clickData.params[InstrumentationParam.ActivityEditsCount] = filteredActivities.filter(activity => activity.action.type === ActionType.Edit).length.toString();
            clickData.params[InstrumentationParam.ActivityMentionsCount] = filteredActivities.filter(activity => activity.action.type === ActionType.Mention).length.toString();

            clickData.params[InstrumentationParam.ActivityTotalCount] = allActivities.length.toString();
            clickData.params[InstrumentationParam.ActivityCountSinceLastOpened] = filteredActivities.length.toString();

            clickData.params[InstrumentationParam.ActivityCollaboration] = this.getActivityCollab();
            clickData.params[InstrumentationParam.ActivityDisplayed] = ActionType[this.activityDescriptionService.displayedActivityType(filteredActivities, this.item.lastViewedTime, false)];
        }

        // Default to spo/onedrive destination
        clickData.params[InstrumentationParam.ClickDestination] = KnownClickDestinations.ExternalPage;

        return clickData;
    }

    private getAttributionClickData(): InstrumentationData {
        const clickData = this.item.getClickDataForPath(
            KnownInstrumentationEvents.MruPathClick,
            KnownInstrumentationActions.Click,
            this.index);
        clickData.params[InstrumentationParam.ItemCategory] = this.listId;
        clickData.params[InstrumentationParam.ResourceId] = this.item.resourceId;
        return clickData;
    }

    private getInstrumentationParams(suggestedActionType?: string) {
        const params: InstrumentationParams = {};
        params[InstrumentationParam.RenderSize] = this.contextMenu.items.length.toString();
        params[InstrumentationParam.Index] = this.index.toString();
        params[InstrumentationParam.DocumentType] = this.item.fileTypeName;
        params[InstrumentationParam.ItemCategory] = this.listId;
        params[InstrumentationParam.Pinned] = this.item.isPinned.toString();
        params[InstrumentationParam.State] = this.view;
        params[InstrumentationParam.ResourceId] = this.item.resourceId;
        params[InstrumentationParam.ActivityCollaboration] = this.getActivityCollab();
        params[InstrumentationParam.SuggestedActionType] = suggestedActionType;

        if (typeof this.relativeIndex !== 'undefined') {
            params[InstrumentationParam.RelativeIndex] = this.relativeIndex.toString();
        }

        return params;
    }

    private maybeGetReferralAndPlatform(actionId: string): { referral: string | null, referralPlatform: KnownReferralPlatform } {
        let referral: string = null;
        let referralPlatform: KnownReferralPlatform;
        if (actionId === 'open' || actionId === 'openInApp') {
            referral = MruFileItem.referralFromFileType(this.item.fileType);
            referralPlatform = actionId === 'open' ? KnownReferralPlatform.Web : KnownReferralPlatform.Native;
        } else if (actionId === 'openFileLocation') {
            referral = MruFileItem.referralFromFileLocation(this.url);
            referralPlatform = this.item.isLocal ? KnownReferralPlatform.Native : KnownReferralPlatform.Web;
        }

        return {
            referral,
            referralPlatform
        };
    }

    private instrumentAction(actionId: string, suggestedActionType?: string) {
        const params = this.getInstrumentationParams(suggestedActionType);
        const { referral, referralPlatform } = this.maybeGetReferralAndPlatform(actionId);

        if (this.item.format === MruFileFormat.OfficeFeedDocument || this.item.format === MruFileFormat.News || this.item.format === MruFileFormat.UpcomingMeeting) {
            let action = 'click';
            switch (actionId) {
                case 'copylink_menu':
                    action = 'copyLink';
                    break;
                case 'share_menu':
                    action = 'share';
            }
            if (actionId === 'join_meeting') {
                this.officeFeedService.logInstrumentation([this.item.feedbackId], [action], [this.item.fromCache ? 'cache' : 'service'], ['joinMeeting']);
            } else if (actionId !== 'remove' && this.item.mruV2Category !== 'myAnalyticsInsight') {
                this.officeFeedService.logInstrumentation([this.item.feedbackId], [action], [this.item.fromCache ? 'cache' : 'service']);
            }
        }

        this.instrumentationService.logClickEvent(KnownInstrumentationEvents.ActionsMenuItemClick, actionId, this.instrumentationArea, referral, referralPlatform, params, [], this.dataSecurityThreshold);
        logUserAction({
            eventName: KnownInstrumentationEvents.ActionsMenuItemClick,
            id: actionId,
            area: this.instrumentationArea as Area,
            subArea: 'ActionsMenuItem',
            result: referral ? 'Refer' : 'Navigate',
            target: referral ? getReferral(referral) : 'Actions'
        }, this.dataSecurityThreshold as unknown as OtelDataSecurityLevel);
    }

    private getActivityCollab(): string {
        return (this.isRecommended || this.isOfficeFeed) && this.item.isCollab ? 'true' : (this.item.activities || []).some(activity => !this.activityDescriptionService.isCurrentUser(activity.actor.user)).toString();
    }

    private getThumbnailUrl(): string {
        if (!this.item.thumbnails) {
            return null;
        }
        if (this.isMicrosoftForms) {
            return this.item.thumbnails.large;
        }

        const validThumbnailExtension = MruItemComponent.acceptedThumbnailExtensions.includes(this.item.extension);
        if ((validThumbnailExtension) && this.item.format === MruFileFormat.StreamsVideo) {
            this.streamsVideoThumbnail = this.officeFeedService.getStreamsThumbnail(this.item.thumbnails.recommendedThumbnail);
            this.streamsVideoThumbnail.then(_thumbnailUrl => {
                this.onThumbnailLoad();
            }).catch(() => {
                this.onThumbnailError();
            });
            return null;
        }

        if (validThumbnailExtension && this.thumbnailApiEnabled && !this.isNewsArticle) {
            this.thumbnail = this.oneDriveService.getThumbnailString(this.item.thumbnails.recommendedThumbnail);
            this.thumbnail.then(_thumbnailUrl => {
                this.onThumbnailLoad();
            }).catch(_ => {
                this.onThumbnailError();
            });
            return null;
        } else {
            // only return thumbnail url if thumbnail api is not enabled, since we don't use thumbnailUrl when it is enabled
            if (this.item.thumbnails && !this.thumbnailApiEnabled) {
                this.onThumbnailLoad();
                if (this.isRecommended || this.isOfficeFeed || this.item.format === MruFileFormat.Trending) {
                    return this.item.thumbnails.recommendedThumbnail || this.item.thumbnails.large;
                } else {
                    return this.item.thumbnails.medium;
                }
            } else {
                this.onThumbnailError();
            }
        }
    }

    private openFolder() {
        if (this.item.isLocal) {
            this.localAppLauncherService.openPathInExplorer(this.item.attributionUrl);
            return;
        }
        // Use UpcomingMeeting joinUrl to launch meeting
        let url = this.isUpcomingMeeting ? this.item.joinUrl
            : this.item.isEmailAttachment ? this.url : this.item.attributionUrl;

        url = this.addLoginHint(url);
        if (this.capabilitiesService.capabilities.contentLauncherEnabled) {
            import('@office-start/launcher-service').then(
                launchSvc => {
                    launchSvc.launchUrl(url, { action: 'OpenFileLocation' });
                }
            );
        } else {
            this.urlLauncherService.openUrl(url, LaunchAction.OpenFileLocation);
        }

        if (this.isUpcomingMeeting) {
            this.instrumentAction('join_meeting');
        }
    }

    private getWdOrigin(openInBrowser = false): string {
        return this.contextService.getWdOrigin(this.getWdOriginTaskForClick(openInBrowser));
    }

    private addLoginHint(url: string): string {
        if (this.item.shouldAddLoginHint()) {
            url = UrlBuilder.appendLoginHint(url, this.clientStartupConfigService.config.loginHint, this.capabilitiesService.capabilities.outgoingLoginHintEnabled);
        }

        return url;
    }

    private getLaunchUrlAndClickId(url: string, openInBrowser = false): [string, string?] {
        url = this.addLoginHint(url);

        if (
            this.mruConfigService.config.addWacParams
            && this.item.fileType !== FileType.Sway
            && this.item.fileType !== FileType.Forms
            && this.item.fileType !== FileType.Pdf
            && this.item.fileType !== FileType.Fluid
            && this.item.fileType !== FileType.PowerBI
            && !this.item.isLocal
            && !this.item.isOnPremOrVanity
            && !this.item.isEmailAttachment
            && this.item.format !== MruFileFormat.News
        ) {
            const clickTime = Date.now();
            const clickId = GuidGenerator.createGuid();
            const scenarioId = this.capabilitiesService.capabilities.scenarioId;

            const queryParams = {
                ct: clickTime,
                wdOrigin: this.getWdOrigin(openInBrowser),
                ...(!this.isConsumer ? { cid: clickId } : {}),
                ...(this.item.fileType === FileType.Stream ? { web: 1 } : {}),
                ...this.wacContentService.getWacHostControlQueryParams(this.item.fileType),
                ...(scenarioId ? { wdscenarioid: scenarioId } : {})
            };

            return [UrlBuilder.appendAndReplaceQueryParams(url, queryParams, true), clickId];
        } else if (this.isMicrosoftForms) {
            const officeRouteItem: OfficeRouteItem = this.officeRouteService.getCurrentRoute();
            const clientContext = this.clientStartupConfigService.config.sharedClientStartupContext;
            const isScuProdPrv = clientContext.deploymentEnvironment === 'prodprv' && clientContext.geoName === 'scu';

            return [UrlBuilder.appendAndReplaceQueryParams(url, {
                lang: this.contextService.sharedContext.officeMarket,
                origin: isScuProdPrv ? OfficeDotComPrvOrigin : OfficeDotComOrigin,
                route: officeRouteItem && officeRouteItem.route ? officeRouteItem.route : undefined,
                sessionId: this.clientStartupConfigService.config.sharedClientStartupContext.sessionId
            }, true), undefined];
        } else if (this.item.fileType === FileType.Stream) {
            return [UrlBuilder.appendQueryParam(url, 'web', '1'), undefined];
        }

        return [url, undefined];
    }

    private createThumbnailAltText(fileType: FileType): string {
        const imageAltText = this.locService.ThumbnailImageAltText;
        switch (fileType) {
            case FileType.Word:
                return this.locService.format(imageAltText, this.locService.ThumbnailWordType);
            case FileType.Excel:
                return this.locService.format(imageAltText, this.locService.ThumbnailExcelType);
            case FileType.PowerPoint:
                return this.locService.format(imageAltText, this.locService.ThumbnailPowerPointType);
            case FileType.OneNote:
            case FileType.OneNoteClassNoteBook:
                return this.locService.format(imageAltText, this.locService.ThumbnailOneNoteType);
            case FileType.Pdf:
                return this.locService.format(imageAltText, this.locService.ThumbnailPdfType);
            case FileType.Visio:
                return this.locService.format(imageAltText, this.locService.ThumbnailVisioType);
            case FileType.Text:
                return this.locService.format(imageAltText, this.locService.ThumbnailTextType);
            case FileType.Sway:
                return this.locService.format(imageAltText, this.locService.ThumbnailSwayType);
            case FileType.Forms:
                return this.locService.format(imageAltText, this.locService.ThumbnailFormsType);
            case FileType.Project:
            case FileType.ProjectOperations:
                return this.locService.format(imageAltText, this.locService.ThumbnailProjectType);
            case FileType.Portfolio:
                return this.locService.format(imageAltText, this.locService.ThumbnailProjectPortfolioType);
            case FileType.NewsArticle:
                return this.locService.format(imageAltText, this.locService.ThumbnailNewsType);
            case FileType.PowerBI:
                return this.locService.format(imageAltText, this.locService.ThumbnailPowerBIType);
            default:
                return '';
        }
    }

    private readonly getToDoUrl = async (): Promise<string> => {
        const workloads: Array<Workload> = await this.workloadsPromise;
        const toDoWorkload = workloads?.find(workload => workload.Id === FirstPartyWorkloadIds.ToDo);
        return toDoWorkload?.Url;
    }

    private getActionPayLoadByName(name: PotentialActionType): string {
        return this.item.potentialAction.filter(action => action.name === name)[0]?.actionPayload;
    }

    private getOfficeStartDocument(): DocumentReact {
        const referralType = FileItem.referralFromFileLocation(this.item.url);
        const isOneDriveForBusinessFile = referralType === KnownWorkloadReferralNames.OneDrive;
        const isSharePointFile = referralType === KnownWorkloadReferralNames.SharePoint;
        const document: DocumentReact = {
            app: this.item.application,
            attribution: this.item.attribution,
            canonicalUrl: this.item.canonicalUrl,
            deepLinkUrl: this.item.teamsDeepLink,
            docId: this.item.docId,
            downloadUrl: this.item.documentUrl,
            driveId: this.item.driveId,
            extension: this.item.extension,
            fileType: FileType[this.item.fileType] as FileTypeReact,
            id: this.item.id,
            isEmailAttachment: this.item.isEmailAttachment,
            isLocalFile: this.item.isLocal,
            isMsftDogfood: this.item.isMsftDogfood,
            isOnPremOrVanity: this.item.isOnPremOrVanity,
            iconUrl: this.item.iconUrl,
            isRedeemed: this.item.isRedeemed ?? (isOneDriveForBusinessFile || isSharePointFile),
            title: this.item.title,
            url: this.item.url,
            webUrl: this.item.webUrl
        };
        return document;
    }

    private wrapAdditionalAction(item: MruAdditionalContextMenuItem): ContextMenuItem {
        return {
            ...item,
            getId: () => item.id,
            executeAction: () => {
                this.instrumentAction(item.id);

                item.executeAction().then(value => {
                    value.forEach(emitter => {
                        switch (emitter.key) {
                            case 'add':
                                this.addItem.emit(emitter.props);
                                break;

                            case 'delete':
                                this.deleteItem.emit(emitter.props);
                                break;

                            case 'disableAction':
                                this.contextMenu.items = this.contextMenu.items.filter(
                                    actionItem => actionItem.getId() !== emitter.props.id
                                );
                                break;
                            default:
                                break;
                        }
                    });
                });
            }
        };
    }

    private wrapAdditionalActionReact(item: MruAdditionalContextMenuItem): DocumentAction {
        return {
            id: item.id,
            title: item.title,
            ariaLabel: item.ariaLabel,
            contentActionOptions: {
                icon: this.getIconReactByIconFontType(item.icon)
            },
            executeAction: () => this.runUnregisteredAction(item.id, () => item.executeAction().then(value => {
                value.forEach(emitter => {
                    switch (emitter.key) {
                        case 'add':
                            this.addItem.emit(emitter.props);
                            break;

                        case 'delete':
                            this.deleteItem.emit(emitter.props);
                            break;

                        case 'disableAction':
                            this.contextMenu.items = this.contextMenu.items.filter(
                                actionItem => actionItem.getId() !== emitter.props.id
                            );
                            break;
                        default:
                            break;
                    }
                });
            })),
            disabled: item.disabled
        };
    }
}
